import faker from 'faker';
import React from 'react';
import { isMap, sum } from 'lodash';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import {
  Box,
  Grid,
  Card,
  Table,
  Divider,
  TableRow,
  Container,
  TableBody,
  TableHead,
  TableCell,
  Typography,
  TableContainer,
  Stack,
  Button,
  IconButton,
  TextField,
  LinearProgress,
  linearProgressClasses,
  OutlinedInput,
  InputAdornment,
  CircularProgress,
  FormControl,
  Tabs,
  Tab,
  Autocomplete,
  Checkbox,
  Tooltip,
  Avatar,
  Collapse,
  Dialog,
  DialogContent,
  Alert,
  DialogActions,
  Paper,
  TablePagination
} from '@material-ui/core';
import { useEffect, useMemo, useRef, useState } from 'react'
// routes
import { PATH_DASHBOARD } from 'src/routes/paths.js';
import { useNavigate, useParams } from 'react-router'
import { Add, AddCircle, AddCircleOutline, AddIcCallOutlined, ArrowBackIos, ArrowForwardIos, CheckBox, Delete, Done, Edit, Info, KeyboardArrowDown, KeyboardArrowUp, KeyboardBackspaceOutlined, Logout, RemoveCircleOutline, Search } from '@material-ui/icons';
import { Link as RouterLink, useLocation, } from 'react-router-dom'
// utils
import { fCurrency } from 'src/utils/formatNumber.js';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import searchFill from '@iconify/icons-eva/search-fill';

// components
import Page from 'src/components/Page.js';
import * as Yup from 'yup';
import Label from 'src/components/Label.js';
import Scrollbar from 'src/components/Scrollbar.js';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs.js';
import InvoiceToolbar from 'src/components/_dashboard/e-commerce/invoice/InvoiceToolbar.js';
import JobCostToolbar from './JobCostToolbar';
import JobCostCartToolbar from './JobCostCartToolbar';
import ConfirmationPopup from 'src/components/confirmationPopup';
import Icon from '@iconify/react';
import { LoadingButton } from '@material-ui/lab';
import { Form, FormikProvider, useFormik } from 'formik';
import axios from 'axios';
import { COMPANY_NAME, REST_API_END_POINT, UNITS } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';
import Modal from 'src/components/_dashboard/blog/ProjectModel';
import { useTheme } from '@material-ui/core/styles';
import LoadingScreen from 'src/components/LoadingScreen';
import { parse } from 'date-fns';
import { empty } from 'src/Helpers/Common';
import CompareJobCost from './CompareJobCost';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import RequestTabUpdates from 'src/components/_dashboard/user/account/RequestTabUpdates'
import JobCostChartSignwise from 'src/components/charts/JobCostChartSignwise';
import CompareJobCostChartMain from './CompareJobCostChartMain';
import JobCostMemberClockInTimer from 'src/components/_dashboard/general-app/JobCostMemberClockInTimer';
import JobCostLogsListing from 'src/components/_dashboard/general-app/JobCostLogsListing';



// ----------------------------------------------------------------------

const INVOICE = {
  id: faker.datatype.uuid(),
  taxes: 5,
  discount: 10,
  status: 'paid',
  invoiceFrom: {
    name: faker.name.findName(),
    address: 'DieSachbearbeiter Choriner Straße 49 10435 Berlin',
    company: faker.company.companyName(),
    email: faker.internet.email(),
    phone: faker.phone.phoneNumberFormat()
  },
  invoiceTo: {
    name: faker.name.findName(),
    address: 'Keas 69 Str. 15234, Chalandri Athens, Greece',
    company: faker.company.companyName(),
    email: faker.internet.email(),
    phone: faker.phone.phoneNumberFormat()
  },
  items: [...Array(1)].map(() => ({
    id: faker.datatype.uuid(),
    title: faker.lorem.sentence(),
    description: faker.lorem.lines(),
    qty: faker.datatype.number({ min: 1, max: 5 }),
    price: faker.datatype.number({ min: 4, max: 99, precision: 0.01 })
  }))
};

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: '100%',
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

const CardMediaStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  position: 'relative',
  justifyContent: 'center',
  cursor: 'pointer',
  paddingTop: 'calc(100% * 9 / 16)',
  '&:before': {
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',

    WebkitBackdropFilter: 'blur(3px)',
    borderTopLeftRadius: theme.shape.borderRadiusMd,
    borderTopRightRadius: theme.shape.borderRadiusMd,

  },
}))

const CoverImgStyle = styled('img')({
  top: 0,
  zIndex: 8,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  position: 'absolute',

})

// ----------------------------------------------------------------------

export default function JobCost({recipeCostId,recipeCostCurrentTab,handleBackToAlljobs,handleClickOpenJobCost,setRecipeCostCurrentTab,popupOn,onDataChange,requestId}) {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const user = JSON.parse(window.localStorage.getItem('user'))
  const subTotal = sum(INVOICE.items.map((item) => item.price * item.qty));
  const total = subTotal - INVOICE.discount + INVOICE.taxes;
  const location = useLocation();
  
  const locationCurrentTab = location?.state?.currentTab || null; 
  const currentTab = popupOn?recipeCostCurrentTab:locationCurrentTab;
  const [projectDetails, setProjectDetails] = useState(null);
  const params = localStorage.getItem("params")
  const req_id = params || requestId
  const [isHover, setIsHover] = useState(false)
  const [productList, setProductList] = useState([]);
  const [initialMaterials, setInitialMaterials] = useState([]);
  const [materialList, setMaterialList] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [filterName, setFilterName] = useState('');
  const [openDeletePop, setOpenDeletePop] = useState(false)
  const [deleteId, setDeleteId] = useState()
  const [renderCards, setRenderCards] = useState(false)
  const [materialsPreview, setMaterialsPreview] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selectedMaterial, setSelectedMaterial] = useState()
  const [manualTotalPayOut, setManualTotalPayOut] = useState(0)
  const [hourlyTotalPayOut, setHourlyTotalPayOut] = useState(0)
  const [excessHourlyPayoutAmount, setExcessHourlyPayoutAmount] = useState(0)
  const [excessManualPayoutAmount, setExcessManualPayoutAmount] = useState(0)
  const [allPayouts, setAllPayouts] = useState([])
  const [manuallyAddedPayouts, setManuallyAddedPayouts] = useState([])
  const [materialPayOut, setMaterialPayOut] = useState(0)
  const [jobCost, setJobCost] = useState(0)
  const [staffTimelogs, setStaffTimelogs] = useState([])
  const [recipe, setRecipe] = useState([])
  const [isRecipe, setIsRecipe] = useState(false)
  const [ingredient, setIngredient] = useState(false)
  const [services, setAllServices] = useState([])
  const [stockProducts, setStockProducts] = useState([])
  const [confirmationPopup, setConfirmationPopup] = useState(false)
  const [editServiceConfirmation, setEditServiceConfirmation] = useState({ open: false, serviceIndex: null, isProductionLabor: false })
  const [excludeManualFromProductionLabor, setExcludeManualFromProductionLabor] = useState(false)
  const [selectedProducts, setSelectedProducts] = useState(false)
  console.log('stockProducts', stockProducts)
  const [additionalMaterials,setAdditionalMaterials] = useState([])
  console.log('additionalMaterialssssssss',additionalMaterials)
  const [allServicesTemp, setAllServicesTemp] = useState([])
  const [additionalServices, setAdditionalServices] = useState([])
  const [projectData, setProjectData] = useState([])
  console.log('projectData**********',projectData);
  
  const [category, setCategory] = useState([{
    "id": length + 1,
    "name": "Product Formula",
    "added_by": 1,
    "status": 1,
    "timestamp": 1711096046,
    "c_id": 1,
    "authorized_by": "Rakesh Skyniche"
  }]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [color, setColor] = useState('#308fe8')
  const [errorFieldId, setErrorFieldId] = useState([]);
  const [jobCostPreview, setJobCostPreview] = useState(false)
  const [servicesPreview, setServicesPreview] = useState(false)
  const [availableServices, setAvailableServices] = useState([])
  const [serviceExpectedHours, setServiceExpectedHours] = useState({})
  const [serviceSearchTerm, setServiceSearchTerm] = useState('')
    const tableContainerRef = useRef(null);
    const [openLabourIdx, setOpenLabourIdx] = useState(null);
  const [isHidden, setIsHidden] = useState(true);
  const [updates, setUpdates] = useState([]);
  const [rowEdit, setRowEdit] = useState({ section: null, index: null });
  const [logs, setLogs] = useState([]);
  const [staffTimelogsGet, setStaffTimelogsGet] = useState([]);
  console.log('staffTimelogsGet-------------', staffTimelogsGet)
  const [totalManualHours, setTotalManualHours] = useState(0);
  console.log('totalManualHours', totalManualHours)
  const [projectMembers, setProjectMembers] = useState([]);
  const [projectTasks, setProjectTasks] = useState([]);
  
  // Pagination state variables for services modal
  const [servicesPage, setServicesPage] = useState(0);
  const [servicesRowsPerPage, setServicesRowsPerPage] = useState(10);
  const [servicesTotalCount, setServicesTotalCount] = useState(0);
  const logo = 'https://www.shutterstock.com/image-photo/checklist-clipboard-task-documentation-management-260nw-2270860299.jpg'

  const { id:paramsId } = useParams();
  const  id  = popupOn ? recipeCostId: paramsId

  const fetchProjectData = async () => {
    try {
      const  res = await axios.post(`${REST_API_END_POINT}jobs/get-project-details-by-id`, { projectId: id });
     setProjectDetails(res.data.result[0])
     localStorage.setItem("params",res.data.result[0].request_id) 
    } catch (error) {
      console.log("error",error)
    }
   }

  useEffect(()=>{
    fetchProjectData()
  },[id])

  useEffect(() => {
    const totalHours = staffTimelogsGet
      ?.filter(log => log.is_manually_added === 1 || log.is_manually_added === "1")
      ?.reduce((accumulator, currentValue) => {
        return accumulator + (parseFloat(currentValue.hours) || 0);
      }, 0) || 0;
    setTotalManualHours(totalHours);
  }, [staffTimelogsGet]);

    const handleScrollLeft = () => {
    tableContainerRef.current.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  };
  
  const handleScrollRight = () => {
    tableContainerRef.current.scrollTo({
      left: tableContainerRef.current.scrollWidth,
      behavior: 'smooth'
    });
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: `hsl(${120 - (progressValue * 1.2)}, ${60}%, 50%)`, // `hsl(${(progressValue * 1.2)}, ${60 + (progressValue * 0.4)}%, 50%)`
    },
  }));
  const fetchData = (noReloadOnClockIn) => {
    if (noReloadOnClockIn) {
      setLoading(false);
    } else {
      setLoading(true);
    }
    try {
      axios.post(`${REST_API_END_POINT}project/fetch-all-job-cost-recipe`, 
        { userId: user.user_id, userType: user.user_type, projectId: id, orderId: projectDetails?.request_id }).then((response) => {
        const productListData = response.data.results
        const stafftimelogs = response.data.stafftimelogs
        let selectedProducts = response.data.selectedMaterials
        let receivedRfpProducts=selectedProducts?.filter(row=>row.rfp===1)
        let rfpProducts = receivedRfpProducts.map(product => ({
            ...product,
            jobcost_unit_cost: product.unit_cost,
            jobcost_quantity: product.quantity,
            jobcost_actual_quantity: product.actual_quantity,
            jobcost_total: product.total,
            available_stock:product.available_stock
        }));
        console.log('rfpProducts:', rfpProducts);

        selectedProducts=selectedProducts.filter(row=>row.rfp===0)
        let initialData = response.data.selectedMaterials
        const allPayouts = response.data.allPayOut
        const project = response.data.projects
        const allMaterials = response.data.allMaterials
        const allRecipes = response.data.allRecipies
        const material = response.data.materials
        let allServices = response.data.allServices
        let stockProducts = response?.data?.stockProducts
        let jobcostLog = response?.data?.jobcostUpdates
        console.log('allServices===', allServices);
        let additionalServices = response.data.additionalServices
        if (additionalServices) {
          setAdditionalServices(additionalServices.reduce((accumulator, currentValue) => {
            return accumulator + parseFloat(currentValue?.jobcost_total_cost || 0);
            // return accumulator + (currentValue?.originalCost * currentValue?.qty);
          }, 0))
        }
          if (material) {
            // setAdditionalMaterials(material)
            console.log('response?.data?.materials')

            setAdditionalMaterials(productListData?.filter(item1 =>
              material?.some(item2 => item1.id === item2.product_id)
            ).map(item1 => {
              let match = material?.find(item2 => item1.id === item2.product_id);
              console.log('item1========',item1)
              console.log('match========',match)
              return { ...item1, ...(match ? 
                { product_id: match.id, 
                  unit: match?.partial_unit ? match?.partial_unit : item1?.unit,
                  // unit_cost:(match?.unit_cost && match?.unit_cost > 0) ? match.unit_cost : match.material_unit_cost, 
                  unit_cost: item1?.inhouse == 0 ? 0 : match?.unit_cost > 0 ? match.unit_cost : match?.material_unit_cost || 0,
                  total:match.total, 
                  quantity: match.quantity, 
                  price: match.price, 
                  match_actual_quantity: match.actual_quantity, 
                  match_actual_total: match.actual_total, 
                  match_actual_unit_price: match.actual_unit_price,
                  taken: match?.taken || 0,
                  isMaterial: item1?.isMaterial || 0 ,
                } : {}) };
            }))
          }

          if (response.data.newstafftimelogs) {
            setStaffTimelogsGet(response.data.newstafftimelogs);
          }

          if (response.data.projectMembers) {
            setProjectMembers(response.data.projectMembers);
          }

          if (response.data.projectTask) {
            setProjectTasks(response.data.projectTask);
          }

        if (project) {
          setProjectData(project)
          let recipe = [{
            "id": 1,
            // "name": project?.job_category_name === 'Time & Material' ? 'Staff Clock-In Time Details' : "Product Formula",
            "name": "Product Formula",
            "added_by": 1,
            "status": 1,
            "timestamp": 1711096046,
            "c_id": 1,
            "authorized_by": "Rakesh Skyniche"
          },
        ]
        // if( project?.job_category_name !== 'Time & Material'){
          let  custom ={
            "id": 2,
            "name": 'Staff Clock-In Time Details' ,
            "added_by": 1,
            "status": 1,
            "timestamp": 1711096046,
            "c_id": 1,
            "authorized_by": "Rakesh Skyniche"
          }
          recipe.push(custom)
        // }
          setCategory([...recipe]);
          setSelectedCategory(1)
        }
        if (allRecipes) {
          setRecipe(allRecipes)
        }
        if (stafftimelogs) {
          setStaffTimelogs(stafftimelogs)
        }
        if (material?.length > 0) {
          setMaterialPayOut(material?.reduce((acc, curr) => acc + curr.total, 0))
        }
        if (allServices) {
          setAllServices(allServices)
          setAllServicesTemp(allServices)
        }
        if (stockProducts) {
          setStockProducts(stockProducts)
        }
        if (jobcostLog){
          setUpdates(jobcostLog)
        }
        if (allPayouts) {
          setAllPayouts(allPayouts || [])
          
          // Store only manually added payouts in separate state
          const manualPayouts = allPayouts.filter(
            p => (p.is_manually_added === 1 || p.is_manually_added === "1") && 
                 (p.service_id === null || p.service_id === undefined || p.service_id === 0 || !p.service_id)
          );
          setManuallyAddedPayouts(manualPayouts || []);
        }
        if (allPayouts?.length > 0) {
          let totalPayOut = allPayouts?.reduce((acc, curr) => acc + curr.amount, 0)
          const totalHourlyPayoutAmount = allPayouts?.filter(payout => payout.is_auto_pay === 1 && !payout.service_id && payout.is_manually_added !== 1)?.reduce((acc, curr) => acc + curr.amount, 0);
          setExcessHourlyPayoutAmount(totalHourlyPayoutAmount)
          const totalManualPayoutAmount = allPayouts?.filter(payout => payout.is_auto_pay !== 1 && !payout.service_id && payout.is_manually_added !== 1)?.reduce((acc, curr) => acc + curr.amount, 0);
          setExcessManualPayoutAmount(totalManualPayoutAmount)

          const summedHourlyPayouts = Object.values(
            allPayouts?.filter(payout => payout.is_auto_pay === 1)?.reduce((acc, payout) => {
              // Create a unique key based on project_id, task_id, and team
              const key = `${payout.project_id}-${payout.task_id || "null"}-${payout.team || "null"}`;
              
              // Initialize the group in the accumulator if it doesn't exist
              if (!acc[key]) {
                acc[key] = {
                  project_id: payout.project_id,
                  task_id: payout.task_id,
                  team: payout.team,
                  total_amount: 0,
                };
              }
          
              // Add the current payout amount to the total for this group, rounded to 2 decimals
              acc[key].total_amount = parseFloat((acc[key].total_amount + payout.amount).toFixed(2));
          
              return acc;
            }, {})
          );
          
          console.log('summedHourlyPayouts===',summedHourlyPayouts);

          const summedManualPayouts = Object.values(
            allPayouts?.filter(payout => payout.is_auto_pay !== 1)?.reduce((acc, payout) => {
              // Create a unique key based on project_id, task_id, and team
              const key = `${payout.project_id}-${payout.task_id || "null"}-${payout.team || "null"}`;
              
              // Initialize the group in the accumulator if it doesn't exist
              if (!acc[key]) {
                acc[key] = {
                  project_id: payout.project_id,
                  task_id: payout.task_id,
                  team: payout.team,
                  total_amount: 0,
                };
              }
          
              // Add the current payout amount to the total for this group, rounded to 2 decimals
              acc[key].total_amount = parseFloat((acc[key].total_amount + payout.amount).toFixed(2));
          
              return acc;
            }, {})
          );
          
          console.log('summedManualPayouts===',summedManualPayouts);
          
          setHourlyTotalPayOut(summedHourlyPayouts?.reduce((acc, curr) => acc + curr.total_amount, 0))
          setManualTotalPayOut(summedManualPayouts?.reduce((acc, curr) => acc + curr.total_amount, 0))
          // setHourlyTotalPayOut(allPayouts.filter(payout => payout.is_auto_pay === 1).reduce((acc, curr) => acc + curr.amount, 0))
          // setManualTotalPayOut(allPayouts.filter(payout => payout.is_auto_pay !== 1).reduce((acc, curr) => acc + curr.amount, 0))
        console.log('allPayoutsallPayoutsallPayouts',allPayouts)
        }
        if (initialData) {
          setInitialMaterials(initialData)
        }
        if (productListData) {
          setProductList(productListData)
        }
        if (allMaterials) {
          setMaterialList(allMaterials)
        }
        if (project) {
          setJobCost(project.cost || 0)
        }
        console.log('response.data--', response.data);
        if (response.data.selectedMaterials?.length) {
          console.log('productListData--', productListData);
          console.log('selectedProducts----', selectedProducts);

          // setSelectedProjects(
          //   productListData
          //     .filter(item1 => selectedProducts.some(item2 => item1.id === item2.product_id))
          //     .map(item3 => {
          //       let match = selectedProducts.find(item2 => item3.id === item2.product_id);
          //       return { ...item3, ...(match ? { product_id: match.product_id, quantity: match.quantity, price: match.unit_price, recipeName: match.recipeName } : {}) };
          //     })
          // );
          console.log('selectedProducts------------',selectedProducts);
          const selectedProjects1 = selectedProducts.map(selectedProduct => {
            const matchingProduct = productListData.find(product => product.id === selectedProduct.product_id);
            if (matchingProduct) {
              return {
                ...matchingProduct,
                unit: selectedProduct?.partial_unit ? selectedProduct?.partial_unit : matchingProduct?.unit,
                product_id: selectedProduct.product_id,
                jobcost_quantity: selectedProduct.quantity,
                jobcost_actual_quantity: selectedProduct.actual_quantity,
                jobcost_unit_cost: selectedProduct.unit_price,
                // jobcost_total:  selectedProduct.total ,
                jobcost_total: selectedProduct.total ||  (selectedProduct.quantity || 0) * (selectedProduct.unit_price || 0),
                recipeName: selectedProduct.recipeName,
                taken:selectedProduct.taken,
                task_id:selectedProduct.task_id,
                finalTaken:selectedProduct.finalTaken,
                customer_order_product_id: selectedProduct?.customer_order_product_id || null,
                job_cost_id:selectedProduct.id,
                available_stock:selectedProduct?.available_stock
              };
            }
            return null; // Handle cases where no matching product is found
          }).filter(project => project !== null);
          console.log('selectedProjects1------------',selectedProjects1);

          setSelectedProjects([...selectedProjects1,...rfpProducts]);
          
          console.log("##############SElected rfp projects",rfpProducts);
        }
      })  
    }catch (error) {
      console.error("Error fetching data:", error);
    }finally{
      setTimeout(() => {
        setLoading(false)
      }, 1000);
    }
  }

  const fetchAvailableServices = async () => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}product/get-all-labour-cost-services`);
      if (response.data && response.data.results && response.data.results.length > 0) {
        setAvailableServices(response.data.results);
        setServicesTotalCount(response.data.results.length);
      }

    } catch (error) {
      console.error('Error fetching available services:', error);
    }
  };

  const fetchAllProductCategory = async () => {
    setLoading(true);
    try {
      axios
        .post(REST_API_END_POINT + 'product/get-all-product-categories')
        .then((res) => {
          let data = res.data
          if (data.status === 1) {
            let length = data.productCategories.length + 2
            console.log("length", length);
            // let recipe = [{
            //   "id": length,
            //   "name": "Product Formula",
            //   "added_by": 1,
            //   "status": 1,
            //   "timestamp": 1711096046,
            //   "c_id": 1,
            //   "authorized_by": "Rakesh Skyniche"
            // }]

            // //  setCategory(data.productCategories)
            // setCategory([...recipe]);
            setSelectedCategory(length)

          }
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    } catch (e) {
      console.error('Exception:', e)
    }finally{
      setTimeout(() => {
        setLoading(false)
      }, 1000);
    }
  }
  console.log("############CAAA", category);
  useEffect(() => {
    if(req_id && req_id !== "undefined" || projectDetails?.request_id){
      console.log("sdfsdfsfd",projectDetails?.request_id)
      fetchData()
    }
    fetchAllProductCategory()
    fetchJobCostLogs();
    fetchAvailableServices();
  }, [renderCards, projectDetails]);

  useEffect(() => {
    if (projectData?.id) {
      fetchJobCostLogs();
    }
  }, [projectData]);

  let grandTotalCost = 0
  const progressValue = useMemo(() => {
    // const Cost = ((selectedProjects.reduce((accumulator, currentValue) => {
    //   return accumulator + (currentValue.unit_cost * currentValue.quantity);
    // }, 0) + Number(manualTotalPayOut) + Number(hourlyTotalPayOut) + Number(materialPayOut)) / jobCost) * 100
    let totalCost = selectedProjects.reduce((accumulator, currentValue) => {
      let newTotal = 0;
      if(currentValue?.taken == 1){
        newTotal = currentValue?.jobcost_total
        // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity
      }
      return accumulator + newTotal;
    }, 0) + manualTotalPayOut + materialPayOut + Math.max(0, (services?.reduce((accumulator, currentValue) => {
    // }, 0) + manualTotalPayOut + hourlyTotalPayOut + materialPayOut + Math.max(0, (services?.reduce((accumulator, currentValue) => {
      let newTotal = 0;
      if(currentValue?.taken == 1){
        // newTotal = currentValue?.originalCost * currentValue?.qty
        // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity
        newTotal = parseFloat(currentValue?.jobcost_total_cost || 0)
      }
      return accumulator + newTotal;
    }, 0) + additionalServices) -(parseFloat(manualTotalPayOut ? parseFloat(manualTotalPayOut) : 0)).toFixed(2)
    // }, 0) + additionalServices) -(parseFloat(manualTotalPayOut ? parseFloat(manualTotalPayOut) : 0) + (hourlyTotalPayOut ? parseFloat(hourlyTotalPayOut) : 0)).toFixed(2)
  )
    let Cost = (totalCost) / jobCost * 100;
    console.log("#################Cost-jobCost", jobCost);
    console.log("#################Cost-totalCost", totalCost);
    console.log("#################Cost-Cost", Cost);
    console.log("#################Cost1",  (manualTotalPayOut ? parseFloat(manualTotalPayOut) : 0) + (hourlyTotalPayOut ? parseFloat(hourlyTotalPayOut) : 0)
  );
    console.log("#################Cost", hourlyTotalPayOut);
    if (Cost > 100) {
      return 100
    } else {
      return Cost
    }
  }, [selectedProjects, manualTotalPayOut, hourlyTotalPayOut, services, additionalServices])

  console.log("###########seselectedProjects", progressValue);
  function isSumGreater(productId, valQty) {
    let sum = 0;
    initialMaterials?.forEach(material => {
      if (material.product_id === productId) {
        sum += material.quantity;
      }
    });
    productList?.forEach(product => {
      if (product.id === productId) {
        sum += product.qty;
      }
    });
    return sum < Number(valQty);
  }
  useEffect(() => {
    const errorFields = [];
    setErrorFieldId([]);
    selectedProjects?.forEach((val) => {
      console.log("###########Rfp value",val.rfp);
      const result = isSumGreater(val.productId, val.jobcost_quantity);
      if (result && val.rfp!=1) {
        errorFields.push({ productId: val.productId, errorText: 'Quantity exceeds the stock' });
      }
    });
    selectedProjects?.forEach((val) => {
      console.log("###########Rfp value",val.rfp);
      if (val.quantity <= 0 && val.rfp!=1) {
        errorFields.push({ productId: val.productId, errorText: 'Enter a valid quantity' });
      }
    });
    if (errorFields.length > 0) {
      setErrorFieldId([])
      setErrorFieldId(errorFields);
    }
  }, [selectedProjects, manualTotalPayOut, hourlyTotalPayOut])

  const handleProjectClick = (project) => {
    console.log("###################qqq", project);

    <Stack direction={{ xs: 'column', md: 'row' }}>
      <Typography variant="body" sx={{ display: 'flex', alignItems: 'center' }}>
        Material Name :
        <span style={{ color: theme.palette.primary.dark, fontWeight: 'bold' }}>
          <Autocomplete
            sx={{ ml: 1, width: 300 }}
            id="combo-box-demo"
            options={selectedMaterial.ingredients}
            value={ingredient}
            onChange={(event, newValue) => setIngredient(newValue)}
            renderInput={(params) => (
              <TextField {...params}
                label="Select a Material" />
            )}
            getOptionLabel={(option) => option.name ? option.name : ''}
          />
        </span>
        Quantity : {selectedMaterial?.ingredients?.find(item => item.product_id === ingredient?.product_id)?.quantity}
      </Typography>
    </Stack>

    setSelectedProjects(prevSelectedProjects => [...prevSelectedProjects, project]);
  };

  const fetchJobCostLogs = async () => {
    const projectId = projectData?.id || id;
    console.log('projectData?.id++++++++++',projectData?.id);
    console.log('Using projectId for request:', projectId);
    
    if (!projectId) {
      console.error("No project ID available for fetching job cost logs");
      return;
    }
    
    try {
      const response = await axios.post(`${REST_API_END_POINT}project/get-job-cost-logs`, { projectId });
      setLogs(response?.data?.data ?? []);
    } catch (error) {
      console.error("Error fetching job cost logs:", error);
    }
  };

  const NewUserSchema = Yup.object().shape({
    quantity: Yup.number().min(0, 'Quantity must be at least 0').test('valid-quantity', 'Enter a valid quantity', (value) => value >= 0).required('Quantity is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      quantity: 1,
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, setFieldError }) => {
      try {
        // if(selectedProjects?.length > 0){
        console.log('selectedProjectsselectedProjectsselectedProjects',selectedProjects)
        const values = selectedProjects?.map(project => ({
          ...(project.product_id ? { id: project.product_id } : {}),
          productId: project.id,
          projectId: id,
          recipeName: project.recipeName ? project.recipeName : "",
          quantity: project.jobcost_quantity,
          unitPrice: project.jobcost_unit_cost || project?.vendor_price,
          actual_quantity: project.jobcost_actual_quantity || 0,
          actual_unit_cost: project.unit_cost || project?.vendor_price || 0,
          actual_total: project.actual_total_cost || project?.vendor_price * project?.jobcost_quantity || 0,
          taken: project.taken,
          task_id: project.task_id || null,
          rfp:project.rfp,
          total: (Number(project.jobcost_total)),
          customer_order_product_id: project?.customer_order_product_id || null
          // total: (Number(project.jobcost_unit_cost) * project.jobcost_quantity)
        }))
        const serviceValues = services?.map(serv => ({
          ...serv,
          taken: serv.taken,
        }))
        // const takenStockProducts = stockProducts?.filter(
        //   serv => serv.taken === 1 && serv.finalTaken !== 1
        // );
        const takenStockProducts = stockProducts?.filter((serv) => {
          const qty = Number(serv.jobcost_quantity ?? 0);
          const inStock = Number(serv.in_stock_no ?? 0);

          const withinStock = inStock > 0 && qty <= inStock; // only allow if qty <= inStock and stock exists

          return serv.taken === 1 && serv.finalTaken !== 1 && withinStock;
        });
        function isSumGreater(productId, valQty) {
          let sum = 0;
          initialMaterials?.forEach(material => {
            if (material.product_id === productId) {
              sum += material.quantity;
            }
          });
          productList?.forEach(product => {
            if (product.id === productId) {
              sum += product.qty;
            }
          });
          return sum < Number(valQty);
        }
        const errorFields = [];
        values.forEach((val) => {
          const result = isSumGreater(val.productId, val.quantity);
          console.log("################val rfp0",val);
          // if (result &&  val.rfp!=1) {
          //   errorFields.push({ productId: val.productId, errorText: 'Quantity exceeds the stock ddd' });
          // }
        });
        values.forEach((val) => {
          if (val.quantity < 0 && val.rfp!=1) {
            errorFields.push({ productId: val.productId, errorText: 'Enter a valid quantity' });
          }
        });
        if (errorFields.length > 0) {
          setErrorFieldId([])
          setErrorFieldId(errorFields);
          // setRenderCards(!renderCards)
          return;
        }
        else {
          setErrorFieldId([])
          axios.post(`${REST_API_END_POINT}project/add-job-cost`, { userId: user.user_id, values,selectedServices:serviceValues,stockProducts:takenStockProducts, projectId: id, recipe: 1,requestId:req_id || projectDetails?.request_id,isReview : (updates?.length > 0 && staffTimelogs?.length > 0) ? true :false }, {
            headers: {
              'Content-Type': 'application/json',
            },
          }).then((response) => {
            if (response.data.status === 1) {
              enqueueSnackbar(response.data.message, { variant: 'success' });
            } else if (response?.data?.message) {
              enqueueSnackbar(response.data?.message, { variant: 'error' });
            }
            else {
              enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
            }
            setRenderCards(!renderCards)
            fetchJobCostLogs();
            onDataChange()
          }).catch((error) => {
            console.log("error",error);
            // enqueueSnackbar('Error adding sssssss Jobcost' + error, { variant: 'error' });
          })
        }
        // }else{
        //   enqueueSnackbar('Please select a material', { variant: 'error' });
        // }
        
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        enqueueSnackbar('Error adding Jobcost' + error, { variant: 'error' });
      }
    }
  });

  const handleDeleteSubmit = async (deletedId) => {
    try {
      // console.log('deletedId----',deletedId);
      setSelectedProjects([...selectedProjects.filter(selected => selected.id !== deletedId)])
      const values = selectedProjects?.filter(selected => selected.id !== deletedId)?.map(project => ({
        ...(project.product_id ? { id: project.product_id } : {}),
        productId: project.id,
        projectId: id,
        quantity: project.jobcost_quantity,
        task_id: project.task_id || null,
        unitPrice: project.jobcost_unit_cost,
        // actual_quantity: project.actual_quantity,
        // actual_unit_cost: project.actual_unit_cost,
        // actual_total: project.actual_total,
        actual_quantity: project.unit_qty || 0,
        actual_unit_cost: project.unit_cost || 0,
        actual_total: project.actual_total_cost || 0,
        recipeName: project.recipeName ? project.recipeName : '', // Ensure match is defined
        total: (Number(project.jobcost_total))
        // total: (Number(project.jobcost_unit_cost) * project.jobcost_quantity)
      }));

      function isSumGreater(productId, valQty) {
        let sum = 0;
        initialMaterials?.forEach(material => {
          if (material.product_id === productId) {
            sum += material.quantity;
          }
        });
        productList?.forEach(product => {
          if (product.id === productId) {
            sum += product.qty;
          }
        });
        return sum < Number(valQty);
      }

      const errorFields = [];
      values.forEach((val) => {
        const result = isSumGreater(val.productId, val.quantity);
        if (result) {
          errorFields.push({ productId: val.productId, errorText: 'Quantity exceeds the stock' });
        }
      });

      values.forEach((val) => {
        if (val.quantity <= 0) {
          errorFields.push({ productId: val.productId, errorText: 'Enter a valid quantity' });
        }
      });

      if (errorFields.length > 0) {
        setErrorFieldId([])
        setErrorFieldId(errorFields);
        return;
      } else {
        setErrorFieldId([])
        axios.post(`${REST_API_END_POINT}project/add-job-cost`, { userId: user.user_id, values, projectId: id, recipe: 1 }, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          if (response.data.status === 1) {
            enqueueSnackbar(response.data.message, { variant: 'success' });
          } else if (response?.data?.message) {
            enqueueSnackbar(response.data.message, { variant: 'error' });
          } else {
            enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
          }
          onDataChange()
          setSelectedProjects([])
          setManualTotalPayOut(0)
          setHourlyTotalPayOut(0)
          setInitialMaterials([])
          setProductList([])
          setMaterialList([])
          setJobCost(0)
          setDeleteId();
          // fetchData()
          setRenderCards(!renderCards)
          onDataChange()
        }).catch((error) => {
          console.error(error);
          enqueueSnackbar('Error adding Jobcost', { variant: 'error' });
        })
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Error adding Jobcost' + error, { variant: 'error' });
    }
  }

  const handleJobCost = async () => {
    console.log("#####################Hifiiiiiiiiiiiiii");
    axios.post(`${REST_API_END_POINT}recipe/update-job-cost-automatically`, { userId: user.user_id, projectId: id, requestId: req_id || projectDetails?.request_id, name: projectData.name }).then((response) => {
      if (response.data.status === 1) {
        // fetchData();
        // setJobCost(0)
        setMaterialList([])
        setProductList([])
        setInitialMaterials([])
        setAllServices([])
        setRecipe([])
        setAdditionalServices([])
        setProjectData([])
        // setMaterialPayOut(0)
        // setHourlyTotalPayOut(0)
        // setManualTotalPayOut(0)
        setSelectedProjects([])
        setRenderCards(!renderCards)
        onDataChange()
        enqueueSnackbar(response.data.message, { variant: 'success' });
      } else if (response.data.status === 0) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
      }
    })
  }
  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };
  const { errors, touched, handleSubmit, isSubmitting, getFieldProps } = formik;
  const materialWithStock = materialList?.filter((data) => data?.total_qty > 0)
  const productWithQty = productList?.filter((data) => data?.qty > 0)
  const navigate = useNavigate()
  const linkState = {
    pathname: `${PATH_DASHBOARD.project.jobCost}/${id}`,
    state: params
  };

  const handleClick = () => {
    if(popupOn){
    handleClickOpenJobCost()
    setRecipeCostCurrentTab(currentTab);
  }else{
    navigate(`${PATH_DASHBOARD.project.jobCost}/${id}`,
      {state: { request: req_id || projectDetails?.request_id,currentTab : currentTab }});
    }
  };

  // grandTotalCost = selectedProjects.reduce((accumulator, currentValue) => {
  //   let newTotal = 0;
  //   if(currentValue?.taken == 1){
  //     newTotal = currentValue?.unit_cost * currentValue?.quantity
  //   }
  //   return accumulator + newTotal;
  // }, 0) + manualTotalPayOut + hourlyTotalPayOut + materialPayOut + Math.max(0, (services?.reduce((accumulator, currentValue) => {
  //   let newTotal = 0;
  //   if(currentValue?.taken == 1){
  //     newTotal = currentValue?.originalCost * currentValue?.qty
  //   }
  //   return accumulator + newTotal;
  // }, 0) + additionalServices) - (manualTotalPayOut ? manualTotalPayOut?.toFixed(2) : 0) + (hourlyTotalPayOut ? hourlyTotalPayOut?.toFixed(2) : 0))

  
  let newMaterialPayOut = parseFloat(materialPayOut.toFixed(2)) || 0;

  let selectedProjectsTotal = selectedProjects?.reduce((accumulator, currentValue) => {
      let newTotal = 0;
      if (currentValue?.taken === 1) {
          newTotal = currentValue?.jobcost_total;
          // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity;
      }
      return accumulator + newTotal;
  }, 0) || 0;
  
  let servicesTotal = services?.reduce((accumulator, currentValue) => {
      let newTotal = 0;
      if (currentValue?.taken === 1) {
          // newTotal = currentValue?.originalCost * currentValue?.qty;
          // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity;
          newTotal = parseFloat(currentValue?.jobcost_total_cost || 0)
          console.log("valueeeeeeeeeeeeee",currentValue)
      }
      return accumulator + newTotal;
  }, 0) || 0;
  
  selectedProjectsTotal = parseFloat(selectedProjectsTotal.toFixed(2));
  servicesTotal = parseFloat(servicesTotal.toFixed(2));
  
  let manualTotal = parseFloat(manualTotalPayOut?.toFixed(2)) || 0;
  let hourlyTotal = parseFloat(hourlyTotalPayOut?.toFixed(2)) || 0;
  
  let newAdditionalServices = additionalServices || 0;
  
  let manualAndHourlyTotal = Math.max(0, manualTotal + hourlyTotal);
  let totalServiceCost = services?.reduce((accumulator, currentValue) => {
      // return accumulator + (currentValue?.originalCost * currentValue?.qty);
      // return accumulator + (currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity);
      return accumulator + parseFloat(currentValue?.jobcost_total_cost || 0);
  }, 0) || 0;
  
  // const handleMaterialCheckboxChange = (index) => {
  //   setSelectedProjects(prevState => 
  //     prevState.map((project, i) => 
  //       i === index ? { ...project, taken: project.taken ? 0 : 1 } : project
  //     )
  //   );
  // };

  const handleMaterialCheckboxChange = (index) => {
    setSelectedProjects((prevState) =>
      prevState.map((project, i) => {
        if (i === index) {
        
          if (project.finalTaken === 1) {
            return {
              ...project,
              taken: project.finalTaken ? 1 : 1,
              // jobcost_quantity: project.taken ? project.jobcost_quantity : project.jobcost_actual_quantity,
              // jobcost_unit_cost: project.taken ? project.jobcost_unit_cost : project.jobcost_actual_unit_cost,
              // // jobcost_total: project.taken ? (Number(project.jobcost_actual_quantity) * Number(project.jobcost_unit_cost)) : (project.jobcost_actual_quantity * Number(project.jobcost_actual_unit_cost)),
              // jobcost_total:  (Number(project.jobcost_actual_quantity) * Number(project.jobcost_unit_cost)) || (project.jobcost_actual_quantity * Number(project.jobcost_actual_unit_cost)),
          
            };
          }
          return {
            ...project,
            taken: project.taken ? 0 : 1,
            jobcost_quantity: project.taken==1 ? project.jobcost_quantity : project.jobcost_actual_quantity,
            jobcost_unit_cost: project.taken==1 ? project.jobcost_unit_cost : project.jobcost_actual_unit_cost,
            // jobcost_total: project.taken ? (Number(project.jobcost_actual_quantity) * Number(project.jobcost_unit_cost)) : (project.jobcost_actual_quantity * Number(project.jobcost_actual_unit_cost)),
            jobcost_total:  (Number(project.jobcost_actual_quantity) * Number(project.unit_cost)) ,
        
          };
        }
        return project;
      })
    );
  };
  
  const handleStockCheckboxChange = (index,isStock) => {
    setStockProducts((prevState) =>
      prevState.map((project, i) => {
        if (i !== index) return project;

        if (project.finalTaken === 1) {
          return {
            ...project,
            taken: 1
          };
        }

        let newTaken = project.taken === 1 ? 0 : 1;
        // if (
        //   newTaken === 1 &&
        //   (project.jobcost_quantity > project.in_stock_no || !project.in_stock_no)
        // ) {
        //   newTaken = 0;
        // }
        // const updatedJobcostQuantity =
        //   newTaken === 1
        //     ? (Number(project.jobcost_quantity) > 0
        //       ? Number(project.jobcost_quantity)
        //       : Number(project.location_quantity) || 1)
        //     : Number(project.jobcost_quantity);
        const updatedJobcostQuantity =
          newTaken === 1
            ? isStock
              ? Number(project.in_stock_no) || 0
              : (Number(project.jobcost_quantity) > 0
                ? Number(project.jobcost_quantity)
                : Number(project.location_quantity) || 1)
            : Number(project.jobcost_quantity);

        const updatedTotalCost =
          newTaken === 1
            ? Number((Number(updatedJobcostQuantity) * Number(project.product_retail_price || 0)).toFixed(2))
            : project.jobcost_total_cost;

        return {
          ...project,
          taken: newTaken,
          jobcost_quantity: updatedJobcostQuantity,
          jobcost_total_cost: updatedTotalCost
        };
      })
    );
  };

  
  // const handleServiceCheckboxChange = (index,service) => {
  //   const isLabour10 = service?.labour_cost_service_id === 10;
  //   console.log('projectprojectprojectproject 2', service)
  //   setAllServices(prevState => 
  //     prevState.map((project, i) => 
  //       i === index ? { ...project, taken: project.taken ? 0 : 1,jobcost_quantity : project.qty  , jobcost_total_cost : project.qty * project.unit_cost} : project
  //     )
  //   );
  // };

const handleServiceCheckboxChange = (index, service) => {
  console.log('serviceeeeeeeeeeeeeeee1', service)
  const isLabour10 = service?.labour_cost_service_id === 10;

  // If production labor and has manual hours, don't trigger any calculations - return early
  if (service?.__isRecipeGroup && totalManualHours > 0) {
    return;
  }
  setAllServices(prevState => {
    const labour10HasQty =
      isLabour10 &&
      prevState.some(
        p => p.labour_cost_service_id === 10 && Number(p.jobcost_quantity) > 0
      );

    return prevState.map(project => {
      const jobcostQtyNum = parseFloat(project.jobcost_quantity) || 0;
      console.log('serviceeeeeeeeeeeeeeee jobcostQtyNum', jobcostQtyNum)
      
      const jobcostQuantity = jobcostQtyNum > 0 ? jobcostQtyNum : Number(project.qty) || 0;
      console.log('serviceeeeeeeeeeeeeeee jobcostQuantity', jobcostQuantity)

      if (isLabour10 && project.labour_cost_service_id === 10) {
        if (project.finalTaken === 1) {
          return { ...project, taken: 1 };
        }

        if (labour10HasQty) {
          return { ...project, taken: project.taken ? 0 : 1 };
        }

        return {
          ...project,
          taken: project.taken ? 0 : 1,
          ...(jobcostQtyNum <= 0 && {
            jobcost_quantity: jobcostQuantity,
            jobcost_total_cost: (project?.jobcost_total_cost && project?.jobcost_total_cost > 0) ? project?.jobcost_total_cost : Number((jobcostQuantity * project.originalCost).toFixed(2)),
          }),
        };
      }
if (service?.__isRecipeGroup && project.recipe_id != null && project.labour_cost_service_id !== 10) {
  // Get manually added payouts total to check if production labor should be locked
  const manuallyAddedPayoutsTotal = manuallyAddedPayouts?.reduce(
    (sum, p) => sum + parseFloat(p.amount || 0), 0
  ) || 0;
  
  const jobcostQtyNum = parseFloat(project.jobcost_quantity) || 0;
  const jobcostQuantity = jobcostQtyNum > 0 ? jobcostQtyNum : Number(project.qty) || 0;

  // ✅ Check if any other items in the recipe group already have values
  const hasOtherRecipeQty = prevState.some(
    s => s.recipe_id === project.recipe_id &&
         s.id !== project.id &&
         Number(s.jobcost_quantity) > 0
  );

  // Determine finalTaken: if manually added hours/payouts exist, must be taken (1), otherwise toggle
  const finalTaken = (manuallyAddedPayoutsTotal > 0 || totalManualHours > 0) ? 1 : (project.taken ? 0 : 1);

  const updated = {
    ...project,
    taken: finalTaken,
  };
console.log('updatedddddddddd 1',updated)
  if (finalTaken === 1 && !hasOtherRecipeQty) {
    updated.jobcost_quantity = jobcostQuantity;
    updated.jobcost_total_cost =
      project?.jobcost_total_cost && project?.jobcost_total_cost > 0
        ? project?.jobcost_total_cost
        : Number((jobcostQuantity * project.originalCost).toFixed(2));
  }
console.log('updatedddddddddd 2',updated)
  return updated;
}

      console.log('service?.id === project.id',service?.id, project.id)
      if ((service?.id === project.id) && !service?.__isRecipeGroup ) {
        // if (project.finalTaken === 1) {
        //   return { ...project, taken: 1 };
        // }

        return {
          ...project,
          taken: project.taken ? 0 : 1,
          ...(jobcostQtyNum <= 0 && {
            jobcost_quantity: jobcostQuantity,
            jobcost_total_cost: (project?.jobcost_total_cost && project?.jobcost_total_cost > 0) ? project?.jobcost_total_cost : Number((jobcostQuantity * project.originalCost).toFixed(2)),
          }),
        };
      }

      console.log('serviceeeeeeeeeeeeeeee project', project)
      return project; // untouched rows
    });
  });
};

  const additionalLaborCost1 = useMemo(() => (
  services.reduce((sum, service) => {
    if (service?.taken !== 1 || service.recipe_id != null || service.labour_cost_service_id === 10) return sum;

    const expected = parseFloat((service.originalCost * service.qty) || 0);
    const actual   = parseFloat(service.jobcost_total_cost || 0);


    const nonExcessAmount = actual > expected ? expected : actual;


     return sum + nonExcessAmount;
  }, 0)
), [services]);

const totalStockCost = useMemo(() => (
  stockProducts.reduce((sum, item) => {
    if (item?.taken !== 1) return sum;

    const cost = parseFloat(item.jobcost_total_cost || 0);
    return sum + cost;
  }, 0)
), [stockProducts]);
console.log('totalStockCosttotalStockCost',totalStockCost)

// const excessLaborCost1 = useMemo(() => {
//   let labourExpected = 0;
//   let labourActual   = 0;
//   let otherExcess    = 0;
// console.log('excessLaborCost1---services--',services)
//   services.forEach(r => {
//     const expected = r.taken == 1 ? (parseFloat(r.originalCost * r.qty) || 0) : 0;
//     const actual   = r.taken == 1 ? (parseFloat(r.jobcost_total_cost) || 0) : 0;

//     if (+r.labour_cost_service_id === 10) {
//       // Group totals for labour id 10
//       labourExpected += expected;
//       labourActual   += actual;
//     } else {
//       // Per-row excess calculation for others
//       if (actual > expected) {
//         otherExcess += actual - expected;
//       }
//     }
//   });

//   const labourExcess = labourActual > labourExpected
//     ? labourActual - labourExpected
//     : 0;
//   console.log('excessLaborCost1---labourExcess', labourExcess)
//   console.log('excessLaborCost1---otherExcess', otherExcess)
//   console.log('excessLaborCost1---excessHourlyPayoutAmount', excessHourlyPayoutAmount)
//   console.log('excessLaborCost1---excessManualPayoutAmount', excessManualPayoutAmount)
//   return +(labourExcess + otherExcess + (excessHourlyPayoutAmount || 0) + (excessManualPayoutAmount || 0)).toFixed(2);
// }, [services, excessHourlyPayoutAmount, excessManualPayoutAmount]);

const excessLaborCost1 = useMemo(() => {
  let labourExpected = 0;
  let labourActual = 0;
  let otherExcess = 0;
  let productionExpected = 0;
  let productionActual = 0;

  services.forEach(s => {
    const expected = s.taken == 1 ? (parseFloat(s.originalCost * s.qty) || 0) : 0;
    const actual = s.taken == 1 ? (parseFloat(s.jobcost_total_cost) || 0) : 0;

    if (+s.labour_cost_service_id === 10) {
// install labour
      labourExpected += expected;
      labourActual += actual;
    } else if (s.recipe_id && s.labour_cost_service_id !== 10 && s.taken == 1) {
// production labour
      productionExpected += expected;
      productionActual += actual;
    } else {
// Per-row excess calculation for others
      if (actual > expected) {
        otherExcess += actual - expected;
      }
    }
  });

  const labourExcess = labourActual > labourExpected ? labourActual - labourExpected : 0;
  const productionExcess = productionActual > productionExpected ? productionActual - productionExpected : 0;

  return +(
    labourExcess +
    productionExcess +
    otherExcess +
    (excessHourlyPayoutAmount || 0) +
    (excessManualPayoutAmount || 0)
  ).toFixed(2);
}, [services, excessHourlyPayoutAmount, excessManualPayoutAmount]);

const installLaborCost = useMemo(() => {
  return services?.reduce((acc, s) => {
    if (s?.labour_cost_service_id === 10 && s?.taken == 1) {
      const expected = Number(s.originalCost || 0) * Number(s.qty || 0);
      const actual = parseFloat(s.jobcost_total_cost || 0);
      const cost = expected > actual ? actual : expected;
      return acc + cost;
    }
    return acc;
  }, 0).toFixed(2);
}, [services]);

// const productionLabourTotal = useMemo(() => {
//   return services?.reduce((acc, s) => {
//     if (s?.recipe_id && s?.labour_cost_service_id !== 10 && s?.taken == 1) {
//       const expected = Number(s.originalCost || 0) * Number(s.qty || 0);
//       const actual = parseFloat(s.jobcost_total_cost || 0);
//       const cost = expected > actual ? actual : expected;
//       console.log(`🧮 ghddddddddddddaf `, s);
//       console.log(`🧮 [ProdLabour] ID=${s.id} name=${s.name}`);
//       console.log('→ ghddddddddddddaf expected:', expected);
//       console.log('→ ghddddddddddddaf actual:', actual);
//       console.log('→ ghddddddddddddaf used cost:', cost);
//       return acc + cost;
//     }
//     return acc;
//   }, 0).toFixed(2);
// }, [services]);

const productionLabourTotal = useMemo(() => {
  // Filter regular production labour services
  const filtered = services?.filter(
    s => s?.recipe_id && s?.labour_cost_service_id !== 10 && s?.taken == 1
  );

  const expected = filtered.reduce((sum, s) => sum + Number(s.originalCost || 0) * Number(s.qty || 0), 0);
  const actual   = filtered.reduce((sum, s) => sum + parseFloat(s.jobcost_total_cost || 0), 0);
  
  // Get manually added tasks' payouts total
  // For Time & Material (project_category === 12), use allPayouts filtered for manually added
  // For other projects, use the pre-filtered manuallyAddedPayouts state
  let manuallyAddedPayoutsTotal = 0;
  
  if (projectData?.project_category === 12) {
    // For Time & Material, get all manually added payouts from allPayouts
    const manuallyAddedPayoutsForTM = allPayouts?.filter(
      p => (p.is_manually_added === 1 || p.is_manually_added === "1")
    ) || [];
    manuallyAddedPayoutsTotal = manuallyAddedPayoutsForTM.reduce(
      (sum, p) => sum + parseFloat(p.amount || 0), 0
    ) || 0;
  } else {
    // For other projects, use the pre-filtered state
    manuallyAddedPayoutsTotal = manuallyAddedPayouts?.reduce(
      (sum, p) => sum + parseFloat(p.amount || 0), 0
    ) || 0;
  }
  
  // For regular services: use Math.min(expected, actual)
  // For manually added tasks: add actual cost directly (no expected cost)
  const regularProductionLabour = Math.min(expected, actual);
  const used = regularProductionLabour + manuallyAddedPayoutsTotal;

  console.log('🧮 [Production Labour]');
  console.log('→ Production Labour Expected Total:', expected);
  console.log('→ Production Labour Actual Total (from services):', actual);
  console.log('→ Regular Production Labour (min):', regularProductionLabour);
  console.log('→ Manually Added Tasks Payouts:', manuallyAddedPayoutsTotal);
  console.log('→ Production Labour Used Total:', used);
  console.log('→ Manually Added Payouts:', manuallyAddedPayouts);

  return used.toFixed(2);
}, [services, manuallyAddedPayouts, allPayouts, projectData?.project_category]);

const materialTotal = useMemo(() => {
  return selectedProjects?.reduce((acc, project) => {
    if (project?.taken === 1) {
      return acc + (parseFloat(project?.jobcost_total) || 0);
    }
    return acc;
  }, 0).toFixed(2);
}, [selectedProjects]);


const excessLabourOnly = useMemo(() => {
  let labourExpected = 0;
  let labourActual = 0;

  services.forEach(service => {
    if (+service.labour_cost_service_id === 10) {
      const expected = parseFloat(service.originalCost) || 0;
      const actual = parseFloat(service.jobcost_total_cost) || 0;
      labourExpected += expected;
      labourActual += actual;
    }
  });

  return labourActual > labourExpected
    ? +(labourActual - labourExpected).toFixed(2)
    : 0;
}, [services]);



console.log('excessQtyCostexcessQtyCost',excessLaborCost1 )
console.log('excessQtyCostexcessQtyCost-manual',excessManualPayoutAmount )
console.log('excessQtyCostexcessQtyCost-hourly',excessHourlyPayoutAmount )
console.log('excessLabourOnlyexcessLabourOnly',excessLabourOnly )

  // const excessLaborCost1 = useMemo(() => (
  //   Math.max(0, manualTotalPayOut + hourlyTotalPayOut - additionalLaborCost1)
  // ), [manualTotalPayOut, hourlyTotalPayOut, additionalLaborCost1]);
  const additionalAmount = ((excessManualPayoutAmount || 0) + (excessHourlyPayoutAmount || 0)) || 0
  
  // Get manually added payouts total
  // For Time & Material (project_category === 12), use allPayouts filtered for manually added
  // For other projects, use the pre-filtered manuallyAddedPayouts state
  let manuallyAddedPayoutsTotal = 0;
  
  if (projectData?.project_category === 12) {
    // For Time & Material, get all manually added payouts from allPayouts
    const manuallyAddedPayoutsForTM = allPayouts?.filter(
      p => (p.is_manually_added === 1 || p.is_manually_added === "1")
    ) || [];
    manuallyAddedPayoutsTotal = manuallyAddedPayoutsForTM.reduce(
      (sum, p) => sum + parseFloat(p.amount || 0), 0
    ) || 0;
  } else {
    // For other projects, use the pre-filtered state
    manuallyAddedPayoutsTotal = manuallyAddedPayouts?.reduce(
      (sum, p) => sum + parseFloat(p.amount || 0), 0
    ) || 0;
  }
  
  grandTotalCost = newMaterialPayOut + selectedProjectsTotal + servicesTotal + totalStockCost + (additionalAmount > 0 ? additionalAmount : 0) + manuallyAddedPayoutsTotal;
  // grandTotalCost = newMaterialPayOut + selectedProjectsTotal + servicesTotal + Math.max(0, manualTotalPayOut - additionalLaborCost1);
  // grandTotalCost = newMaterialPayOut + selectedProjectsTotal + servicesTotal + Math.max(0, manualTotalPayOut + hourlyTotalPayOut - additionalLaborCost1);
  grandTotalCost = parseFloat(grandTotalCost.toFixed(2));

  console.log('costtttttttttttt services',services)
  console.log('costtttttttttttt',servicesTotal,manualAndHourlyTotal,totalServiceCost,newAdditionalServices, additionalAmount)

  console.log('grandTotalCostservicesservices=12=newMaterialPayOut==',newMaterialPayOut);
  console.log('grandTotalCostservicesservices=12=selectedProjectsTotal==',selectedProjectsTotal);
  console.log('grandTotalCostservicesservices=12=servicesTotal==',servicesTotal);
  console.log('grandTotalCostservicesservices=12=additionalAmount==',additionalAmount);
  console.log('servicesservices=12=manualAndHourlyTotal==',manualAndHourlyTotal);
  console.log('servicesservices=12=manualTotalPayOut==',manualTotalPayOut);
  console.log('servicesservices=12=hourlyTotalPayOut==',hourlyTotalPayOut);
  console.log('servicesservices=12=additionalLaborCost1==',additionalLaborCost1);
  console.log('servicesservices=12=totalServiceCost==',totalServiceCost);
  console.log('servicesservices=12=newAdditionalServices==',newAdditionalServices);
  console.log('grandTotalCostservicesservices=12=excessLaborCost1==',excessLaborCost1);

  const isEditing = (section, idx) => rowEdit.section === section && rowEdit.index === idx;

  const handleEditRow = (section, idx, serviceId) => {
    if (section === 'services') {
      // Only show confirmation when starting to edit (not when clicking Done)
      if (!isEditing('services', idx)) {
        // Check if this is production labor by checking the consolidated services
        const consolidatedServices = services?.reduce((acc, curr) => {
          if (curr.labour_cost_service_id === 10) {
            if (!acc.some(item => item.labour_cost_service_id === 10)) {
              acc.push({ ...curr, __isRecipeGroup: false });
            }
          } else if (curr.recipe_id != null) {
            if (!acc.some(item => item.__isRecipeGroup)) {
              acc.push({ ...curr, __isRecipeGroup: true });
            }
          } else {
            acc.push(curr);
          }
          return acc;
        }, []);
        
        const isProductionLabor = consolidatedServices?.[idx]?.__isRecipeGroup === true;
        
        setEditServiceConfirmation({ 
          open: true, 
          serviceIndex: idx,
          isProductionLabor: isProductionLabor 
        });
      } else {
        // If already editing, delete staff task timelogs when Done is clicked
        if (serviceId) {
          deleteStaffTaskTimelogsByService(serviceId, excludeManualFromProductionLabor);
        }
        // Stop editing and reset the exclude flag
        setExcludeManualFromProductionLabor(false);
        setRowEdit({ section: null, index: null });
      }
    } else {
      // For other sections, edit directly
      setRowEdit(prev =>
        prev.section === section && prev.index === idx
          ? { section: null, index: null }
          : { section, index: idx }  
      );
    }
  };

  const handleEditServiceConfirm = () => {
    const { serviceIndex, isProductionLabor } = editServiceConfirmation;
    
    // If it's production labor, exclude manual hours and payouts from calculation
    if (isProductionLabor) {
      setExcludeManualFromProductionLabor(true);
    }
    
    setRowEdit({ section: 'services', index: serviceIndex });
    setEditServiceConfirmation({ open: false, serviceIndex: null, isProductionLabor: false });
  };

  const handleEditServiceCancel = () => {
    setEditServiceConfirmation({ open: false, serviceIndex: null, isProductionLabor: false });
  };

  const handleServiceAdd = async (service) => {
    try {
      // Get the expected hours from the state
      const expectedHours = serviceExpectedHours[service.id] || 0;
      
      const serviceData = {
        name: service.name,
        id: service.id,
        type_id: service.type_id || service.service_type_id,
        cost: service.cost || 0,
        workflow_id: service.workflow_id || service.workflow_id,
        expected_hours: expectedHours,
        status: 1,
        is_addition_service: 1,
        total_cost: service.total_cost,
        makeAsTask:service?.makeAsTask || 0,
        makeInstallCard:service?.makeInstallCard || 0,
      };

      const response = await axios.post(`${REST_API_END_POINT}request/add-request-service`, {
        serviceData,
        userId: user?.user_id,
        requestId: req_id || projectDetails?.request_id,
        projectId: id,
        orderId: req_id || projectDetails?.request_id,
        projectCategory: projectData?.project_category
      });

      if (response.data.status === 1) {
        // const newService = {
        //   ...service,
        //   id: response.data.serviceId,
        //   request_id: req_id,
        //   added_by: user?.user_id,
        //   status: 1
        // };
        
        // setAllServices(prev => [...prev, newService]);
        
        // setAllServices(prev => [...prev]);
        setAllServices(response.data.services || []);
        
        enqueueSnackbar('Service added successfully', { variant: 'success' });
      } else {
        enqueueSnackbar(response.data.message || 'Failed to add service', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error adding service:', error);
      enqueueSnackbar('Error adding service', { variant: 'error' });
    }
  };

  // Pagination handlers for services modal
  const handleServicesChangePage = (event, newPage) => {
    setServicesPage(newPage);
  };

  const handleServicesChangeRowsPerPage = (event) => {
    setServicesRowsPerPage(parseInt(event.target.value, 10));
    setServicesPage(0);
  };

  const handleDeleteRow = (section, idx, selectedProjects, serviceId, is_from_job = 0, is_recipe_group = false) => {
    let itemToDelete;
    let message;
    let deleteEndpoint;
    let deleteData;

    if (section === 'services') {
      // Handle service deletion
      if (!serviceId) {
        enqueueSnackbar('Service ID not found', { variant: 'error' });
        return;
      }
      message = `Are you sure you want to delete this service?`;
      const from_job = projectData.job_category_name === 'Time & Material' ? 1 : is_from_job
      deleteEndpoint = `${REST_API_END_POINT}request/delete-request-service`;
      deleteData = { serviceId, userId: user?.user_id, from_job, is_recipe_group, request_id: req_id || projectDetails?.request_id, projectId: id, orderId: req_id || projectDetails?.request_id };
    } else {
      // Handle material/stock deletion
      itemToDelete = selectedProjects?.[idx];
      if (!itemToDelete?.job_cost_id) {
        enqueueSnackbar('Job cost ID not found', { variant: 'error' });
        return;
      }
      message = `Are you sure you want to delete this job cost item?`;
      deleteEndpoint = `${REST_API_END_POINT}project/job-cost-delete-item`;
      deleteData = { jobCostId: itemToDelete.job_cost_id, user_id: user?.user_id };
    }

    setConfirmationPopup({
      open: true,
      handleClick: async () => {
        try {
          const response = await axios.post(deleteEndpoint, deleteData);

          if (response.data.status === 1) {
            if (section === 'materials') {
              setSelectedProjects(prev => prev.filter((_, i) => i !== idx));
            } else if (section === 'stock') {
              setStockProducts(prev => prev.filter((_, i) => i !== idx));
            } else if (section === 'services') {
              // setAllServices(prev => prev.filter((item, i) => item.id !== serviceId));
              // // Trigger re-render to recalculate totals
              // setAllServices(prev => [...prev]);
              setAllServices(response.data.services || []);
            }

            // Show success message
            enqueueSnackbar(response.data.message || 'Item deleted successfully', { variant: 'success' });
            if (section !== 'services') {
              fetchJobCostLogs();
            }
          } else {
            enqueueSnackbar(response.data.message || 'Failed to delete item', { variant: 'error' });
          }
        } catch (error) {
          console.error('Error deleting item:', error);
          enqueueSnackbar('Error deleting item', { variant: 'error' });
        } finally {
          setConfirmationPopup({ ...confirmationPopup, open: false });
        }
      },
      handleClose: () => {
        setConfirmationPopup({ ...confirmationPopup, open: false });
      },
      message
    });
  };

  const deleteStaffTaskTimelogsByService = async (serviceId, isProductionLabor = false) => {
    try {
      const response = await axios.post(`${REST_API_END_POINT}project/delete-staff-task-timelogs-by-service`, {
        serviceId,
        projectId: id,
        userId: user?.user_id,
        isProductionLabor: isProductionLabor
      });
      

      if (response.data.status === 1) {
        console.log(`Deleted ${response.data.deletedCount} staff task timelogs for service ${serviceId}`);
        
        // If production labor, clear manually added data without full refresh
        if (isProductionLabor) {
          // Remove manually added timelogs where service_id and installation_id are NULL
          setStaffTimelogsGet(prev => 
            prev.filter(log => {
              const isManuallyAdded = log.is_manually_added === 1 || log.is_manually_added === "1";
              const hasNoServiceId = log.service_id === null || log.service_id === undefined || log.service_id === 0;
              const hasNoInstallationId = log.installation_id === null || log.installation_id === undefined || log.installation_id === 0;
              
              // Keep if NOT (manually added AND no service_id AND no installation_id)
              return !(isManuallyAdded && hasNoServiceId && hasNoInstallationId);
            })
          );
          
          // Clear manually added payouts (where service_id is NULL)
          setManuallyAddedPayouts([]);
          
          // Also update allPayouts to remove manually added payouts with service_id NULL
          setAllPayouts(prev => 
            prev.filter(p => {
              const isManuallyAdded = p.is_manually_added === 1 || p.is_manually_added === "1";
              const hasNoServiceId = p.service_id === null || p.service_id === undefined || p.service_id === 0;
              
              // Keep if NOT (manually added AND no service_id)
              return !(isManuallyAdded && hasNoServiceId);
            })
          );
        }
      } else {
        console.error('Failed to delete staff task timelogs:', response.data.message);
      }
    } catch (error) {
      console.error('Error deleting staff task timelogs:', error);
    }
  };

  return (
    (loading || !projectData) ?
      <Stack alignItems='center' justifyContent='center' mt={10}>
        <LoadingScreen />
      </Stack> :
      <Page title={`Job Calculator |${COMPANY_NAME}`} mt={3} >
        <Container  >
          {popupOn?<Button
            variant="outlined"
            type="button"
            // component={RouterLink}
            // to={PATH_DASHBOARD.project.viewproject + id}
            // onClick={()=>{
            //   navigate(`${PATH_DASHBOARD.project.viewproject}/${id}`,
            //     {state: { currentTab : currentTab }});
            // }}
            onClick={handleBackToAlljobs}
            sx={{ alignItems: 'flex-end', mb: 4 }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back to Job Details
          </Button>:<Button
            variant="outlined"
            type="button"
            // component={RouterLink}
            // to={PATH_DASHBOARD.project.viewproject + id}
            onClick={()=>{
              navigate(`${PATH_DASHBOARD.project.viewproject}/${id}`,
                {state: { currentTab : currentTab }});
            }}
            // onClick={handleBackToAlljobs}
            sx={{ alignItems: 'flex-end', mb: 4 }}
            startIcon={
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>
            }
          >
            Back to Job Details
          </Button>}

          <Button
            variant="outlined"
            type="button"
            onClick={()=>{ setJobCostPreview(true); }}
            sx={{ alignItems: 'flex-end', mb: 4, ml:4 }}
          >
            Expected V/S Actual
          </Button>
          <CompareJobCostChartMain
            logs={logs}
            projectData={projectData}
            setLogs={setLogs}
            requestId={projectData?.request_id}
            fetchJobCostLogs={fetchJobCostLogs} tmLabel={projectData?.job_category_name === 'Time & Material' ? 'T&M' : undefined} id={id} />
          <Paper variant='outlined' sx={{ p: 3, mb: 3 }}>
            <Stack direction={'row'} spacing={2} display={'flex'} alignItems={'center'} justifyContent={'space-between'}>
              <Box width={'30%'}>
                <HeaderBreadcrumbs
                  heading={
                  <>
                    {"Job Editing"} {projectData?.job_category_name === 'Time & Material' ? <Label variant="filled" color="info">T&M</Label> : ''}
                  </>}
                />
              </Box>
  
              {/* <Box width={'50%'}> */}
              <Stack spacing={2} mb={5} sx={{ mr: '7% !important' }} width={'50%'}>
                {/* {projectData?.job_category_name === 'Time & Material' ? 
                  <Typography variant="subtitle2">Expected Budget (Material + Service) : {jobCost}</Typography>
                :
                  <Typography variant="subtitle2">Expected Budget (Product Formula Cost + Labor Cost) : {jobCost}</Typography>
                } */}
                <Box sx={{ display: 'flex', alignItems: 'center', }}>
                  <Box sx={{ width: '100%', mr: 1 }}>
                    <BorderLinearProgress variant="determinate" value={progressValue} />
                  </Box>
                  <Box sx={{ minWidth: 35 }}>
                    <Typography variant="body2" color="text.secondary">{Math.round(progressValue) || 0}%</Typography>
                  </Box>
                </Box>
              </Stack>
              {/* </Box> */}
  
            </Stack>
  
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Grid container spacing={3}>
              <Grid item md={5} xs={12}>
              {/* <Button
                variant="outlined"
                type="button"
                onClick={()=>handleClick()}
                // component={RouterLink}
                // to={linkState}
                sx={{ mb: 4 }}
              > */}
                {/* {projectData?.job_category_name=='Time & Material' ? 'Go To Materials' : 'Add Material'} */}
                {/* {projectData?.job_category_name=='Time & Material' ? 'Add Material' : 'Add Material'}
              </Button> */}
              </Grid>
              <Grid item md={7} xs={12}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                  <div style={{ textAlign: 'left' }}>
                    {/* {
                       projectData?.job_category_name=='Time & Material' ?
                       ''
                       : */}
                       
                    <Typography variant="subtitle2">
                      
                      Actual Labor Cost: {parseFloat(additionalLaborCost1).toFixed(2)}
                      {/* Actual Labor Cost: {projectData?.job_category_name=='Time & Material' ? '0.00' :
                      (services?.reduce((accumulator, currentValue) => {
                        // return accumulator + (currentValue?.originalCost * currentValue?.qty);
                        return accumulator + (currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity);
                      }, 0) || 0).toFixed(2)} */}
                    </Typography>
  {/* } */}
                  </div>
                  {
                    updates?.length > 0 ? ''
                    :
                  <div style={{ textAlign: 'right' }}>
                  {/* {projectData?.job_category_name=='Time & Material' ?
                  ""
                  : */}
                    <Typography variant="subtitle2">
                      Manual Staff Pay Out: {manualTotalPayOut ? manualTotalPayOut.toFixed(2) : 0}
                    </Typography>
  {/* } */}
                    <Typography variant="subtitle2">
                      Hourly Staff Pay Out: {hourlyTotalPayOut ? hourlyTotalPayOut.toFixed(2) : 0}
                    </Typography>
                    <Typography variant="subtitle2" sx={{color: 'yellow'}}>
                      Total Staff Pay Out: {
                        manualTotalPayOut ? (
                          hourlyTotalPayOut ? (
                            (parseFloat(manualTotalPayOut) + parseFloat(hourlyTotalPayOut)).toFixed(2)
                          ) : manualTotalPayOut.toFixed(2)
                        ) : hourlyTotalPayOut ? hourlyTotalPayOut.toFixed(2) : 0
                      }
                    </Typography>
                  </div>
                  }
                </Stack>
              </Grid>
            </Grid>
            </div>
            <Grid item md={12} xs={12} direction='column' sx={{ display: 'flex', }}>
              {/* {projectData.jobcost === 1 ? 
              <Button variant='outlined' sx={{ color: 'error.main', cursor:'none', borderColor: 'error.main' }}>
                {projectData.notifyJobcost}
              </Button> : ""} */}
              {projectData.jobcost === 1 ? (
                <Button
                  variant='outlined'
                  sx={{
                    color: 'error.main',
                    borderColor: 'error.main',
                    pointerEvents: 'none',
                    userSelect: 'text',
                  }}
                >
                  {projectData.notifyJobcost}
                </Button>
              ) : ""}
              {/* <Box sx={{ position: 'relative', display: 'inline-block', margin: '20px' }}>
                {projectData.jobcost === 1 ? (
                    <Typography
                    variant="outlined"
                    sx={{
                      position: 'absolute',
                      top: '-20px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      // backgroundColor: 'white',
                      padding: '5px 15px',
                      color: 'error.main',
                      fontSize: '26px',
                      border: '1px solid',
                      borderColor: 'error.main',
                      borderRadius: '4px',
                      whiteSpace: 'nowrap',
                      wordWrap:'break-word'
                    }}
                    >
                      {projectData.notifyJobcost}
                    </Typography>
                ) : ''}
              </Box> */}
            </Grid>
            {projectData.jobcost === 1 && <Box sx={{ display: 'flex', justifyContent: 'space-around' }}>
              
              <Button
                variant="outlined"
                type="submit"
                onClick={()=>navigate(PATH_DASHBOARD.products.material)}
                sx={{ mb: 4, mt: 3,ml:2 }}
                startIcon={ <Logout /> }
              >
               Go to Material Inventory
              </Button>
              <Button
              variant="outlined"
              type="submit"
              onClick={handleJobCost}
              sx={{ mb: 4, mt: 3, }}
            >
              Update JobCost
            </Button>
            </Box>}
  
            <Grid container spacing={3}>
              <Grid item md={5} xs={12} sx={{ display: isHidden ? 'none' : 'block' }}>
  
                <Tabs
                  value={selectedCategory}
                  sx={{
                    backgroundColor: theme.palette.grey[700],
                    borderRadius: 2,
                    mb: 1,
                  }}
                  onChange={(e, newValue) => handleCategoryChange(newValue)}
                  variant="scrollable"
                  aria-label="scrollable auto tabs example"
                  allowScrollButtonsMobile
                  autoFocus
                  scrollButtons="auto"
                >
                  {category.map((category) => (
                    <Tab key={category.id} sx={{ ml: 3,}}
                      disableRipple
                      autoCapitalize={category.name}
                      label={category.name}
                      value={category.id} />
                  ))}
                </Tabs>
                {/* {projectData?.job_category_name === 'Time & Material' ? 
                  <Card
                    sx={{
                      p: 1,
                      height: '560px',
                      overflowY: 'auto',
                      // backgroundColor: 'transparent',
                      // background: 'transparent',
                      '&::-webkit-scrollbar': {
                        width: '0.4em',
                      },
                      '&::-webkit-scrollbar-track': {
                        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0,0,0,.1)',
                        borderRadius: '4px',
                      },
                    }}
                  >
                    <Grid container spacing={1}>
                      <Scrollbar>
                        <TableContainer sx={{ minWidth: 340 }}>
                          <Table>
                            <TableHead
                              sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                // '& th': { backgroundColor: 'transparent' }
                              }}
                            >
                              <TableRow>
                                <TableCell align="center">
                                  <Typography variant="body1">Staff Name</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1">Task</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1">Clocked-In Hours</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1">Hourly Rate</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1">Total</Typography>
                                </TableCell>
                              </TableRow>
                            </TableHead>
  
                            <TableBody>
                              {staffTimelogs?.map((log, logIndex) => (
                                <TableRow
                                  key={`log_${logIndex}`}
                                  sx={{
                                    borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                  }}
                                >
                                  <TableCell align="center">
                                    <Typography variant="subtitle2">{log.staff_name}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography variant="subtitle2">{log.isDriver==1 ? (log.task_name ||'Labor Install') : log.task_name}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography variant="subtitle2">{parseFloat(log.hours || 0)?.toFixed(4)}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography variant="subtitle2">{log.hourly_rate || 20}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography variant="subtitle2">{parseFloat(log.total_cost || 0)?.toFixed(2)}</Typography>
                                  </TableCell>
                                </TableRow>
                              ))
                              }
  
                            </TableBody>
                          </Table>
                        </TableContainer>
  
                      </Scrollbar>
                    </Grid>
                  </Card>
                :  */}
                  <>
                  {
                    selectedCategory==1?
                    <>
                  
                  <SearchStyle
                    sx={{ backgroundColor: '#05191f', height: 40, mt: 1 }}
                    value={filterName}
                    onChange={handleFilterByName}
                    placeholder="Search Material"
                    startAdornment={
                      <InputAdornment position="start">
                        <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
                      </InputAdornment>
                    }
                  />
                  <Card
                    variant='outlined'
                    sx={{
                      p: 3,
                      mt: 2,
                      height: '360px',
                      overflowY: 'auto',
                      backgroundColor: 'transparent',
                      background: 'transparent',
                      '&::-webkit-scrollbar': {
                        width: '0.4em',
                      },
                      '&::-webkit-scrollbar-track': {
                        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                      },
                      '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(0,0,0,.1)',
                        borderRadius: '4px',
                      },
                    }}
                  >
                    <Grid container spacing={1}>
                      {recipe.map((recipeItem, index) => (
                        <Grid key={index} item xs={6} sm={4} md={4}> {/* Adjusted md to 4 */}
                          <Card
                            variant='outlined'
                            onMouseEnter={() => setIsHover(true)}
                            onMouseLeave={() => setIsHover(false)}
                            sx={{
                              minWidth: 100,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              textAlign: 'center',
                              transition: 'transform 0.2s',
                              '&:hover': {
                                transform: 'scale(1.02)',
                              },
                            }}
                            // onClick={() => { setMaterialsPreview(true); setIsRecipe(true); setSelectedMaterial(recipeItem) }}
                          >
                            {/* Display truncated recipe name */}
                            <div style={{ fontWeight: 'bold', marginBottom: '10px', marginTop: '10px' }}>
                              R: {recipeItem.name.split(' ').slice(0, 2).join(' ')}
                            </div>
                            {/* Display counts */}
                            <div>
                              Materials: {recipeItem.ingredients.length}
                            </div>
                            <div>
                              Services: {recipeItem.services.length}
                            </div>
                            {/* Highlighted productName */}
                            <div style={{ fontWeight: 'bold', color: 'yellow', marginTop: '10px', marginBottom: '10px' }}>
                              C: {recipeItem.productName}
                            </div>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </Card>
  
                  </>
                  :
                  <Card
                  sx={{
                    p: 1,
                    mt: 1,
                    boxShadow:'none',
                    height: '560px',
                    overflowY: 'auto',
                    // backgroundColor: 'transparent',
                    // background: 'transparent',
                    '&::-webkit-scrollbar': {
                      width: '0.4em',
                    },
                    '&::-webkit-scrollbar-track': {
                      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: 'rgba(0,0,0,.1)',
                      borderRadius: '4px',
                    },
                  }}
                >
                  <Grid container spacing={1}>
                    <Scrollbar>
                      <TableContainer sx={{ minWidth: 340 }}>
                        <Table>
                          <TableHead
                            sx={{
                              // borderBottom: (theme) => `solid 1px ${theme.palette.divider}`, 
                              // '& th': { backgroundColor: 'transparent' }
                            }}
                          >
                            <TableRow>
                              <TableCell align="center">
                                <Typography variant="body1">Staff Name</Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body1">Task</Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body1">Clocked-In Hours</Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body1">Hourly Rate</Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="body1">Total</Typography>
                              </TableCell>
                            </TableRow>
                          </TableHead>
  
                          <TableBody>
                            {updates?.length > 0  ? '' :
                            staffTimelogs?.map((log, logIndex) => (
                              <TableRow
                                key={`log_${logIndex}`}
                                sx={{
                                  borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                }}
                              >
                                <TableCell align="center">
                                  <Typography variant="subtitle2">{log.staff_name}</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="subtitle2">{log.isDriver==1 ? (log?.task_name ||'Labor Install') : (log?.task_name === 'null' || log?.task_name == null ? 'N/A' : log?.task_name) }</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="subtitle2">{parseFloat(log.hours || 0)?.toFixed(4)}</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="subtitle2">{log.hourly_rate || 0}</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {/* <Typography variant="subtitle2">{parseFloat(log.total_cost || (parseFloat(log.hours || 0)?.toFixed(4) * log.hourly_rate) || 0)?.toFixed(2)}</Typography> */}
                                  <Typography variant="subtitle2">{parseFloat((parseFloat(log.hours || 0)?.toFixed(4) * log.hourly_rate) || 0)?.toFixed(2)}</Typography>
                                </TableCell>
                              </TableRow>
                            ))
                            }
  
                          </TableBody>
                        </Table>
                      </TableContainer>
  
                    </Scrollbar>
                  </Grid>
                  {updates?.length > 0 ? (<Box sx={{mt:2}}>
                   <RequestTabUpdates updates={updates?.length > 0 ? updates : []} />
                  </Box>) : ''}
                </Card>
                  }
                  </>
                
              </Grid>
              <Grid item md={isHidden ? 12 : 7} xs={12}>
                <Box sx={{ position: 'relative' }}>
                <Card variant='outlined' sx={{ mt: 1 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', py: 2, pl: 2, flexDirection: 'row', gap: 2, }}>
                      <Tooltip title={isHidden ? 'Show Details' : 'Hide Details'} placement="top">
                        <IconButton
                          onClick={() => setIsHidden(!isHidden)}
                          sx={{
                            backgroundColor: '#f5f5f528',
                            border: '1px solid #ccc',
                            borderRadius: '4px',
                            width: 30,
                            height: 40,
                            color: '#ffffff',
                            '&:hover': {
                              backgroundColor: '#44424263',
                            },
                            transition: 'all 0.2s ease-in-out',
                          }}
                        >
                          {isHidden ? <ArrowForwardIos fontSize="small" /> : <ArrowBackIos fontSize="small" sx={{ marginLeft: '7px' }} />}
                        </IconButton>
                      </Tooltip>
                    <Typography variant="h4" noWrap>Expense</Typography>
                  </Box>
                  <Box sx={{ width: "100%", display: "flex", alignItems: 'center', justifyContent: "flex-end", my: 2, mr: 5 }}>
                    {/* Color indicators for stock types */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mr: 2 }}>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: "#ffffff", borderRadius: "20%", border: "1px solid black" }} />
                        <Typography variant="body2">Materials</Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: "yellow", borderRadius: "20%", border: "1px solid black" }} />
                        <Typography variant="body2">Services</Typography>
                      </Box>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: "#ffc0cb", borderRadius: "20%", border: "1px solid black" }} />
                        <Typography variant="body2">Additional Materials</Typography>
                      </Box>
                      {
                        projectData?.job_category_name == 'Time & Material' ? ""
                        :
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <Box sx={{ width: 20, height: 20, backgroundColor: "#1ccaff", borderRadius: "20%", border: "1px solid black" }} />
                        <Typography variant="body2">Stock Catalogs</Typography>
                      </Box>
                      }
                    </Box>
                  </Box>
                  <FormikProvider value={formik}>
                    <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                      <Scrollbar
                        sx={{
                          height: '320px'
                        }}>
                        <TableContainer sx={{ minWidth: 550 }} ref={tableContainerRef}>
                          <Table>
                            <TableHead
                              sx={{
                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                '& th': { backgroundColor: 'transparent' }
                              }}
                            >
                              <TableRow>
                                 <TableCell align="center">
                                </TableCell>
                                <TableCell align="center">
                                </TableCell>
                                  <TableCell align="center">
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1" >Name</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  {/* {projectData?.job_category_name === 'Time & Material' 
                                    ? ''
                                    :  */}
                                    <Typography variant="body1" >Product Formula</Typography>
                                  {/* } */}
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1" noWrap>Expected Qty</Typography>
                                </TableCell>
                                <TableCell align="center">
                                  <Typography variant="body1" noWrap>Actual Qty</Typography>
                                </TableCell>
                                {/* <TableCell align="center">
                                  <Typography variant="body1" noWrap>Unit price</Typography>
                                </TableCell> */}
                                <TableCell align="center">
                                  <Typography variant="body1" noWrap>Total </Typography>
                                </TableCell>
                                {(selectedProjects?.length > 0 || stockProducts?.length > 0) && (
                                  <TableCell align="center">
                                    <Typography variant="body1">Actions</Typography>
                                  </TableCell>
                                )}
                                {/* <TableCell align="center">
                                  <Typography variant="body1" noWrap></Typography>
                                </TableCell> */}
                              </TableRow>
                            </TableHead>
  
                            <TableBody>
                              {console.log("#############selectedProjects", selectedProjects)}
                              {selectedProjects?.map((selectedProject, index) => {
                                let qtyExceed = 0
                                let unitName = UNITS?.filter((item) => item?.id == selectedProject?.unit)
                                let shortUnitName = unitName?.[0]?.short_name || "";
                                return (
                                  <TableRow
                                    key={index}
                                    sx={{
                                      borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                      backgroundColor: (selectedProject?.taken==1) ? theme.palette.divider : null,
                                    }}
                                  >
                                                <TableCell padding="checkbox" onClick={handleScrollRight}>
                                                <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                                                <ArrowForwardIos color="#ffffff" sx={{width:"20px",fontSize:'1rem'}}/>
                                                  </IconButton>
                                                </TableCell>
  
                                    <TableCell align="center">
                                      <Stack direction={'row'}>
                                    <Checkbox key={index}
                                      sx={{cursor:'pointer'}}
                                      checked={(selectedProject?.taken==1) ? true : false}
                                      onChange={()=>{ handleMaterialCheckboxChange(index)}}
                                      color="primary"
                                    />
                                      </Stack>
                                    </TableCell>
                                     <TableCell align="center">
                                    {(selectedProject?.finalTaken==1 && projectData?.syncWithQuickbooks ==1) ?<Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                    :""}
                                     </TableCell>
                                    <TableCell align="center">
                                      <Box sx={{ maxWidth: 130, justifyContent: 'center', alignItems: 'center' }}>
                                        <Tooltip title={selectedProject?.name||selectedProject?.productName || selectedProject?.rfpProductName}>
                                          <Typography variant="subtitle2" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{selectedProject?.name||selectedProject?.productName || selectedProject?.rfpProductName}</Typography>
                                        </Tooltip>
                                        <Tooltip title={selectedProject?.barcode||"(Sub contract)"}>
                                          <Typography variant="subtitle2" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{selectedProject?.barcode||"(Sub contract)"}</Typography>
                                        </Tooltip>
                                        {/* <span style={{ color: theme.palette.error.main }}>
                                          {selectedProjects.rfp!=1?selectedProjects?.filter(item => item.id === selectedProject?.id)?.reduce((accumulator, currentValue) => {
                                            const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                            const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                            const stock = (initialQuantity + productQuantity) - currentValue?.quantity;
                                            return stock >= 0 ? ('Stock left : ' + stock.toFixed(2)) : '';
                                          }, 0) || '':''}
                                        </span> */}
                                      </Box>
                                    </TableCell>
                                    <TableCell>{<Typography variant="subtitle2" >{selectedProject?.recipeName ? selectedProject.recipeName : ""}</Typography>}</TableCell>
                                    {/* <TableCell align="left">1</TableCell> */}
                                    <TableCell align="center">
                                      <TextField
                                        sx={{ width: '80%' }}
                                        type='text'
                                        label={(selectedProject?.unit == 4) ? "Quantity" : shortUnitName}
                                        disabled={true}
                                        value={selectedProject.jobcost_actual_quantity}
                                        onKeyPress={(event) => {
                                          event.preventDefault();
  
                                        }}
                                        onChange={(event) => {
                                          // console.log('errorFieldId--2----',errorFieldId)
                                          let newValue = event.target.value;
                                          if (newValue.startsWith('-')) {
                                            newValue = newValue.slice(1);
                                          }
                                          const updatedProjects = selectedProjects.map(p => {
                                            if (p.id === selectedProject.id) {
                                              return {
                                                ...p,
                                                quantity: event.target.value
                                              };
                                            }
                                            return p;
                                          });
                                          const qtyExceed = selectedProjects?.filter(item => item.id === selectedProject?.id)?.reduce((accumulator, currentValue) => {
                                            const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                            const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                            const stock = initialQuantity + productQuantity;
                                            const balanceStock = stock - event.target.value;
                                            return (balanceStock < 0)
                                          }, 0) || 0
  
                                          setSelectedProjects(updatedProjects);
                                        }}
                                        // error={errorFieldId?.length > 0 && errorFieldId?.find(data => data.productId === selectedProject.id) || ''}
                                        //  helperText={errorFieldId?.length > 0 && errorFieldId.find(field => field.productId === selectedProject.id)?.errorText || ''}
                                        
                                         // error={Boolean(touched.quantity && errors.quantity)}
                                        // helperText={touched.quantity && errors.quantity}
                                        InputProps={{
                                          inputProps: {
                                            min: 1,
                                            max: () => {
                                              const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                              const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                              return initialQuantity + productQuantity;
                                            }
                                          }
                                        }}
                                        defaultValue={1}
                                      />
                                      
                                    </TableCell>
                                    <TableCell align="center">
                                      <TextField
                                        sx={{ width: '80%' }}
                                        type="number"
                                        // disabled={selectedProject.finalTaken == 1}
                                        disabled={!isEditing('materials', index)} 
                                        label={(selectedProject?.unit == 4) ? "Quantity" : shortUnitName}
                                        // disabled={true}
                                        value={selectedProject.jobcost_quantity}
                                        // onKeyPress={(event) => {
                                        //   event.preventDefault();
  
                                        // }}
                                        // onChange={(event) => {
                                        //   // console.log('errorFieldId--2----',errorFieldId)
                                        //   let newValue = event.target.value;
                                        //   if (newValue.startsWith('-')) {
                                        //     newValue = newValue.slice(1);
                                        //   }
                                        //   const updatedProjects = selectedProjects.map(p => {
                                        //     if (p.id === selectedProject.id) {
                                        //       return {
                                        //         ...p,
                                        //         quantity: event.target.value,
                                        //         jobcost_quantity: event.target.value
                                        //       };
                                        //     }
                                        //     return p;
                                        //   });
                                        //   const qtyExceed = selectedProjects?.filter(item => item.id === selectedProject?.id)?.reduce((accumulator, currentValue) => {
                                        //     const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                        //     const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                        //     const stock = initialQuantity + productQuantity;
                                        //     const balanceStock = stock - event.target.value;
                                        //     return (balanceStock < 0)
                                        //   }, 0) || 0
  
                                        //   setSelectedProjects(updatedProjects);
                                        // }}
                                        // onChange={(event) => {
                                        //   let newValue = event.target.value;
                                        //   if (newValue.startsWith('-')) {
                                        //     newValue = newValue.slice(1); // Prevent negative values
                                        //   }
                                        
                                        //   const updatedProjects = selectedProjects.map((p, idx) => {
                                        //     if (idx === index) {
                                        //       const updatedProject = {
                                        //         ...p,
                                        //         jobcost_quantity: newValue,
                                        //         jobcost_total: newValue * Number(p.jobcost_unit_cost),
                                        //       };
                                        
                                        //       // If the value entered is less than the first box value, uncheck the checkbox
                                        //       if (Number(newValue) < Number(p.jobcost_actual_quantity)) {
                                        //         updatedProject.taken = 0;
                                        //       } 
                                        //       // If the value exceeds the first box value, reset it to match the first box value
                                        //       else if (Number(newValue) > Number(p.jobcost_actual_quantity)) {
                                        //         updatedProject.jobcost_quantity = p.jobcost_actual_quantity;
                                        //         updatedProject.taken = 1; // Keep the checkbox checked
                                        //       } else {
                                        //         updatedProject.taken = 1; // Keep the checkbox checked for valid values
                                        //       }
                                        
                                        //       return updatedProject;
                                        //     }
                                        //     return p;
                                        //   });
                                        
                                        //   setSelectedProjects(updatedProjects);
                                        // }}
  
                                        onChange={(event) => {
                                          let newValue = event.target.value;

                                          if (Number(newValue) > Number(selectedProject?.available_stock)) {
                                            enqueueSnackbar(
                                              'Stock not available. Available stock: ' + selectedProject.available_stock,
                                              { variant: 'error' }
                                            );
                                        
                                            // Reset taken only, don’t update quantity
                                            setSelectedProjects((prevState) =>
                                              prevState.map((project, idx) =>
                                                idx === index
                                                  ? {
                                                      ...project,
                                                      taken: 0, // reset taken
                                                    }
                                                  : project
                                              )
                                            );
                                        
                                            return;
                                          }
                                        
                                          // Prevent negative values
                                          if (newValue.startsWith('-')) {
                                            newValue = newValue.slice(1);
                                          }
                                        
                                          setSelectedProjects((prevState) =>
                                            prevState.map((project, idx) => {
                                              if (idx === index) {
                                                // Get the maximum allowed value from the first box
                                                const maxAllowedValue = Number(project.jobcost_actual_quantity);
                                        
                                                // Constrain the value to the maximum allowed
                                                const constrainedValue = Math.min(Number(newValue), maxAllowedValue);
                                        
                                                // Determine the value of "taken" based on the input
                                                const taken = constrainedValue === maxAllowedValue ? 1 : 0;
                                        
                                                // Update the project with the constrained value and "taken" status
                                                return {
                                                  ...project,
                                                  jobcost_quantity:Number(newValue), //constrainedValue,
                                                  jobcost_total: Number(newValue) * Number(project.jobcost_unit_cost), //constrainedValue
                                                  taken: taken,
                                                };
                                              }
                                              return project;
                                            })
                                          );
                                        }}
                                        
                                        
                                        
                                        error={errorFieldId?.length > 0 && errorFieldId?.find(data => data.productId === selectedProject.id) || ''}
                                         helperText={errorFieldId?.length > 0 && errorFieldId.find(field => field.productId === selectedProject.id)?.errorText || ''}
                                        // error={Boolean(touched.quantity && errors.quantity)}
                                        // helperText={touched.quantity && errors.quantity}
                                        InputProps={{
                                          inputProps: {
                                            min: 1,
                                            max: () => {
                                              const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                              const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                              return initialQuantity + productQuantity;
                                            }
                                          }
                                        }}
                                        defaultValue={1}
                                      />
                                      
                                    </TableCell>
  
                                    <TableCell align="center">{fCurrency(Number(selectedProject?.jobcost_total))}</TableCell>
                                    {!isEditing('materials', index) ? (<TableCell align="center">
                                      <>
                                        <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                          {/* {selectedProject.finalTaken == 1 ? '' : ( */}
                                            <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('materials', index)}>
                                            <Edit size="small" sx={{ fontSize: '24px' }} />
                                          </Button>
                                        {/* // )} */}
                                          <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('materials', index, selectedProjects)}>
                                            <Delete size="small" sx={{ fontSize: '24px' }}/>
                                          </Button>
                                          <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} onClick={handleScrollLeft} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                        </Stack>
                                      </>

                                    </TableCell>) : <TableCell align="center">
                                      <>
                                        <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                          <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('materials', index)}>
                                            <Done size="small" sx={{ fontSize: '24px' }}/>
                                          </Button>
                                          <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('materials', index, selectedProjects)}>
                                            <Delete size="small" sx={{ fontSize: '24px' }}/>
                                          </Button>
                                          <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} onClick={handleScrollLeft} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                        </Stack>
                                      </>
                                    </TableCell>}
                                      {/* <TableCell padding="checkbox" onClick={handleScrollLeft}>
                                     <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                     </TableCell> */}
  
                                  </TableRow>
                                )
                              })}
  
                                {/* {stockProducts?.map((selectedProject, index) => {
                                  let unitName = UNITS?.filter((item) => item?.id == selectedProject?.unit)
                                  let shortUnitName = unitName?.[0]?.short_name || "";
                                  return (
                                    <TableRow
                                      key={index}
                                      sx={{
                                        borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                        backgroundColor: (selectedProject?.taken == 1) ? theme.palette.divider : null,
                                      }}
                                    >
                                      <TableCell padding="checkbox" onClick={handleScrollRight}>
                                        <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} >
                                          <ArrowForwardIos color="#ffffff" sx={{ width: "20px", fontSize: '1rem' }} />
                                        </IconButton>
                                      </TableCell>
  
                                      <TableCell align="center">
                                        <Stack direction={'row'}>
                                          <Checkbox key={index}
                                            sx={{ cursor: 'pointer' }}
                                            checked={(selectedProject?.taken == 1) ? true : false}
                                            onChange={() => { handleMaterialCheckboxChange(index) }}
                                            color="primary"
                                          />
                                        </Stack>
                                      </TableCell>
                                      <TableCell align="center">
                                        {(selectedProject?.finalTaken == 1 && projectData?.syncWithQuickbooks == 1) ? <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover", }} />
                                          : ""}
                                      </TableCell>
                                      <TableCell align="center">
                                        <Box sx={{ maxWidth: 130, justifyContent: 'center', alignItems: 'center' }}>
                                          <Tooltip title={selectedProject?.name || selectedProject?.productName || selectedProject?.rfpProductName}>
                                            <Typography variant="subtitle2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selectedProject?.name || selectedProject?.productName || selectedProject?.rfpProductName}</Typography>
                                          </Tooltip>
                                          <Tooltip title={selectedProject?.barcode || "(Sub contract)"}>
                                            <Typography variant="subtitle2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{selectedProject?.barcode || "(Sub contract)"}</Typography>
                                          </Tooltip>
                                        </Box>
                                      </TableCell>
                                      <TableCell>{<Typography variant="subtitle2" >{selectedProject?.recipeName ? selectedProject.recipeName : ""}</Typography>}</TableCell>
                                      <TableCell align="center">
                                        <TextField
                                          sx={{ width: '80%' }}
                                          type='text'
                                          label={(selectedProject?.unit == 4) ? "Quantity" : shortUnitName}
                                          disabled={true}
                                          value={selectedProject.jobcost_actual_quantity}
                                          onKeyPress={(event) => {
                                            event.preventDefault();
  
                                          }}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            if (newValue.startsWith('-')) {
                                              newValue = newValue.slice(1);
                                            }
                                            const updatedProjects = selectedProjects.map(p => {
                                              if (p.id === selectedProject.id) {
                                                return {
                                                  ...p,
                                                  quantity: event.target.value
                                                };
                                              }
                                              return p;
                                            });
                                            const qtyExceed = selectedProjects?.filter(item => item.id === selectedProject?.id)?.reduce((accumulator, currentValue) => {
                                              const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                              const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                              const stock = initialQuantity + productQuantity;
                                              const balanceStock = stock - event.target.value;
                                              return (balanceStock < 0)
                                            }, 0) || 0
  
                                            setSelectedProjects(updatedProjects);
                                          }}
                                          InputProps={{
                                            inputProps: {
                                              min: 1,
                                              max: () => {
                                                const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                                const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                                return initialQuantity + productQuantity;
                                              }
                                            }
                                          }}
                                          defaultValue={1}
                                        />
  
                                      </TableCell>
                                      <TableCell align="center">
                                        <TextField
                                          sx={{ width: '80%' }}
                                          type="number"
                                          disabled={selectedProject.finalTaken == 1}
                                          label={(selectedProject?.unit == 4) ? "Quantity" : shortUnitName}
                                          // disabled={true}
                                          value={selectedProject.jobcost_quantity}
                                          onChange={(event) => {
                                            let newValue = event.target.value;
                                            // Prevent negative values
                                            if (newValue.startsWith('-')) {
                                              newValue = newValue.slice(1);
                                            }
                                            setSelectedProjects((prevState) =>
                                              prevState.map((project, idx) => {
                                                if (idx === index) {
                                                  // Get the maximum allowed value from the first box
                                                  const maxAllowedValue = Number(project.jobcost_actual_quantity);
  
                                                  // Constrain the value to the maximum allowed
                                                  const constrainedValue = Math.min(Number(newValue), maxAllowedValue);
  
                                                  // Determine the value of "taken" based on the input
                                                  const taken = constrainedValue === maxAllowedValue ? 1 : 0;
  
                                                  // Update the project with the constrained value and "taken" status
                                                  return {
                                                    ...project,
                                                    jobcost_quantity: constrainedValue,
                                                    jobcost_total: constrainedValue * Number(project.jobcost_unit_cost),
                                                    taken: taken,
                                                  };
                                                }
                                                return project;
                                              })
                                            );
                                          }}
                                          error={errorFieldId?.length > 0 && errorFieldId?.find(data => data.productId === selectedProject.id) || ''}
                                          helperText={errorFieldId?.length > 0 && errorFieldId.find(field => field.productId === selectedProject.id)?.errorText || ''}
                                          InputProps={{
                                            inputProps: {
                                              min: 1,
                                              max: () => {
                                                const initialQuantity = initialMaterials?.find(item => item.product_id === selectedProject.id)?.quantity || 0;
                                                const productQuantity = productList?.find(item => item.id === selectedProject.id)?.qty || 0;
                                                return initialQuantity + productQuantity;
                                              }
                                            }
                                          }}
                                          defaultValue={1}
                                        />
  
                                      </TableCell>
  
                                      <TableCell align="center">{fCurrency(Number(selectedProject?.jobcost_total))}</TableCell>
  
                                      <TableCell padding="checkbox" onClick={handleScrollLeft}>
                                        <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} >
                                          <ArrowBackIos color="#ffffff" sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                        </IconButton>
                                      </TableCell>
  
                                    </TableRow>
                                  )
                                })} */}
                                {stockProducts?.map((selectedProject, index) => {
                                  let unitName = UNITS?.find((item) => item?.id == selectedProject?.unit);
                                  let shortUnitName = unitName?.short_name || "";
  
                                  return (
                                    <TableRow
                                      key={index}
                                      sx={{
                                        borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                        backgroundColor: selectedProject?.taken == 1 ? theme.palette.divider : null,
                                      }}
                                    >
                                      {/* Scroll Right */}
                                      <TableCell padding="checkbox" onClick={handleScrollRight}>
                                        <IconButton
                                          sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }}
                                        >
                                          <ArrowForwardIos sx={{ width: "20px", fontSize: '1rem' }} />
                                        </IconButton>
                                      </TableCell>
  
                                      {/* Checkbox */}
                                      <TableCell align="center">
                                        <Stack direction={'row'}>
                                          <Checkbox
                                            sx={{ cursor: 'pointer' }}
                                            checked={selectedProject?.taken == 1}
                                            onChange={() => {
                                              if((selectedProject?.location_quantity > selectedProject.in_stock_no || selectedProject?.jobcost_quantity > selectedProject.in_stock_no ) && selectedProject.taken !==1){
                                                setConfirmationPopup(true)
                                                setSelectedProducts(selectedProject)
                                              }else{
                                                handleStockCheckboxChange(index);
                                              }
                                            }}
                                            color="primary"
                                          />
                                        </Stack>
                                      </TableCell>
                                      <Dialog open={confirmationPopup} onClose={() => setConfirmationPopup(false)}>
                                        <DialogContent sx={{ mb: -2 }}>
                                          <Stack direction="column" spacing={2}>
                                            <Typography variant='h6'></Typography>
                                            <Alert severity="warning">
                                              {(selectedProducts?.in_stock_no > 0 && (selectedProducts?.location_quantity > selectedProducts.in_stock_no)) ? 
                                              `Stock (${selectedProducts?.in_stock_no}) is lower than the required quantity (${selectedProducts?.location_quantity}). Do you want to set the Actual quantity to the available stock (${selectedProducts?.in_stock_no}) ?`
                                            : (selectedProducts?.in_stock_no > 0 && (selectedProducts?.jobcost_quantity > selectedProducts.in_stock_no)) ?
                                             `Stock (${selectedProducts?.in_stock_no}) is lower than the Actual quantity (${selectedProducts?.jobcost_quantity}). Do you want to set the Actual quantity to the available stock (${selectedProducts?.in_stock_no}) ?`
                                            : `This product is out of stock (${selectedProducts?.in_stock_no}). Add stock to proceed.`
                                            }
                                              </Alert>
                                          </Stack>
                                        </DialogContent>
                                        <DialogActions>
                                          <Button variant='outlined' color='inherit' onClick={() => setConfirmationPopup(false)}>No</Button>
                                          <Button
                                            variant="contained"
                                            sx={{ boxShadow: 'none' }}
                                            disabled={selectedProducts?.in_stock_no <= 0}
                                            onClick={() => {
                                              setConfirmationPopup(false);
                                              const isStock = true
                                              handleStockCheckboxChange(index,isStock);
                                              // handleUpdateStatus(status);
                                            }}
                                          >
                                            Yes
                                          </Button>
                                        </DialogActions>
                                      </Dialog>
  
                                      {/* QB Icon (leave empty or show conditionally) */}
                                      <TableCell align="center">
                                        {(selectedProject?.finalTaken == 1 && projectData?.syncWithQuickbooks == 1)
                                          ? <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover" }} />
                                          : ""}
                                      </TableCell>
  
                                      {/* Product Name + Barcode */}
                                      <TableCell align="center">
                                        <Box sx={{ maxWidth: 130 }}>
                                          <Tooltip title={selectedProject?.product_name}>
                                            <Typography variant="subtitle2" noWrap 
                                            // sx={{color:"#1ccaff"}}
                                            >
                                              {selectedProject?.product_name}
                                            </Typography>
                                          </Tooltip>
                                          <Tooltip title={selectedProject?.barcode||""}>
                                          <Typography variant="subtitle2" sx={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>{selectedProject?.barcode||""}</Typography>
                                        </Tooltip>
                                            {
                                            (selectedProject.finalTaken !== 1 &&
                                              (selectedProject.jobcost_quantity > selectedProject.in_stock_no || !selectedProject.in_stock_no) &&
                                              selectedProject.jobcost_quantity > 0) && (
                                              <Typography
                                                variant="caption"
                                                color="error"
                                                sx={{ mt: 0.5, display: 'block' }}
                                              >
                                                Stock is less than required quantity
                                              </Typography>
                                            )}
                                        </Box>
                                      </TableCell>
                                      <TableCell>
                                        <Typography variant="subtitle2">
                                        </Typography>
                                      </TableCell>
  
                                      <TableCell align="center">
                                        <TextField
                                          sx={{ width: '80%' }}
                                          type='text'
                                          label={shortUnitName || "Qty"}
                                          disabled
                                          value={selectedProject.location_quantity}
                                        />
                                      </TableCell>
                                      {/* Editable Quantity Input */}
                                      <TableCell align="center">
                                      <TextField
                                        sx={{ width: '80%' }}
                                          type="number"
                                          // disabled={selectedProject.finalTaken == 1}
                                          disabled={selectedProject.finalTaken == 1 || !isEditing('stock', index)}
                                          label={shortUnitName || "Quantity"}
                                          // value={selectedProject.jobcost_quantity}
                                          value={parseInt(selectedProject.jobcost_quantity) || 0}
                                          onChange={(event) => {
                                            let newQty = parseFloat(event.target.value || 0);
                                            if (newQty < 0) newQty = 0;
  
                                            setStockProducts((prev) =>
                                              prev.map((item, idx) => {
                                                if (idx !== index) return item;
  
                                                const canTake = item.in_stock_no > 0 && item.in_stock_no >= newQty;
  
                                                return {
                                                  ...item,
                                                  jobcost_quantity: newQty,
                                                  jobcost_total_cost: (newQty * parseFloat(item.product_retail_price || 0)).toFixed(2),
                                                  taken: canTake && newQty > 0 ? 1 : 0
                                                };
                                              })
                                            );
                                          }}
                                          inputProps={{
                                            min: 0,
                                          }}
                                        />
                                      </TableCell>
                                      {/* Total */}
                                      <TableCell align="center">
                                        {fCurrency(Number(selectedProject?.jobcost_total_cost || 0))}
                                      </TableCell>
                                      {!isEditing('stock', index) ? (<TableCell align="center">
                                        <>
                                          <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                            {/* {selectedProject.finalTaken == 1 ? '' : ( */}
                                              <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('stock', index)} >
                                              <Edit size="small" sx={{ fontSize: '24px' }} />
                                            </Button>
                                          {/* // )} */}
                                            <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('stock', index, selectedProjects)}>
                                              <Delete size="small" sx={{ fontSize: '24px' }}/>
                                            </Button>
                                            <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} onClick={handleScrollLeft} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                          </Stack>
                                        </>

                                      </TableCell>) : <TableCell align="center">
                                        <>
                                          <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                            <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('stock', index)}>
                                              <Done size="small" sx={{ fontSize: '24px' }}/>
                                            </Button>
                                            <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('stock', index,selectedProjects)}>
                                              <Delete size="small" sx={{ fontSize: '24px' }}/>
                                            </Button>
                                            <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} onClick={handleScrollLeft} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                          </Stack>
                                        </>
                                      </TableCell>}
                                      {/* Scroll Left */}
                                      {/* <TableCell padding="checkbox" onClick={handleScrollLeft}>
                                        <IconButton
                                          sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }}
                                        >
                                          <ArrowBackIos sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                        </IconButton>
                                      </TableCell> */}
                                    </TableRow>
                                  );
                                })}
                              {console.log("servicesservicesservicesservices", services)}
                              {
                              // services
                              //     ?.reduce((acc, curr) => {
                              //       if (curr.labour_cost_service_id === 10) {
                              //         if (!acc.some(item => item.labour_cost_service_id === 10)) {
                              //           const combined = { ...curr }
                              //           const sameItems = services.filter(s => s.labour_cost_service_id === 10)
  
                              //           combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0)
                              //           combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0)
                              //           combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2)
  
                              //           acc.push(combined)
                              //         }
                              //       } else {
                              //         acc.push(curr)
                              //       }
                              //       return acc
                              //     }, [])
                              //     .map((service, serviceIndex) => (
                                services?.reduce((acc, curr) => {
                                  // ✅ Case 1: Consolidate install labour - untouched logic
                                  if (curr.labour_cost_service_id === 10) {
                                    if (!acc.some(item => item.labour_cost_service_id === 10)) {
                                      const combined = { ...curr };
                                      const sameItems = services.filter(s => s.labour_cost_service_id === 10);
  
                                      combined.qty = sameItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                                      combined.jobcost_quantity = sameItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                                      combined.jobcost_total_cost = sameItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0).toFixed(2);
  
                                      acc.push(combined);
                                    }
                                  }
  
                                  // Case 2: Consolidate ALL services that have any recipe_id (not null) but NOT labour
                                  else if (curr.recipe_id != null) {
                                    const alreadyAdded = acc.some(item => item.__isRecipeGroup);
                                    if (!alreadyAdded) {
                                      const recipeItems = services.filter(s => s.recipe_id != null && s.labour_cost_service_id !== 10);
                                      if (recipeItems.length > 0) {
                                        const combined = { ...recipeItems[0] };
                                        
                                        // Calculate manuallyAddedPayoutsTotal
                                        const manuallyAddedPayoutsTotalForCost = manuallyAddedPayouts?.reduce(
                                          (sum, p) => sum + parseFloat(p.amount || 0), 0
                                        ) || 0;
                                        
                                        // If excludeManualFromProductionLabor is true, exclude manual hours and payouts
                                        const manualHoursToAdd = excludeManualFromProductionLabor ? 0 : totalManualHours;
                                        const manualPayoutsToAdd = excludeManualFromProductionLabor ? 0 : manuallyAddedPayoutsTotalForCost;
                                        
                                        combined.qty = manualHoursToAdd + recipeItems.reduce((sum, s) => sum + Number(s.qty || 0), 0);
                                        combined.jobcost_quantity = manualHoursToAdd + recipeItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                                        combined.jobcost_total_cost = (manualPayoutsToAdd + recipeItems.reduce((sum, s) => sum + Number(s.jobcost_total_cost || 0), 0)).toFixed(2);
                                        combined.__isRecipeGroup = true; // internal flag to prevent duplicates
                                        // Set taken to 1 if manual hours or payouts exist, or if any recipe item is taken
                                        combined.taken = (totalManualHours > 0 || manuallyAddedPayoutsTotalForCost > 0 || recipeItems.some(s => s.taken == 1)) ? 1 : (combined.taken || 0);

                                        acc.push(combined);
                                      }
                                    }
                                  }
                                  else {
                                    acc.push(curr);
                                  }
  
                                  return acc;
                                }, [])
                                .map((service, serviceIndex) => (
                                  <React.Fragment key={`service_${serviceIndex}`}>
                                <TableRow
                                  // key={`service_${serviceIndex}`}
                                  sx={{
                                    borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                    backgroundColor: (service?.taken==1) ? theme.palette.divider : null,
                                  }}
                                >
                                    {console.log("jfdnifhijskdfnf", service)}
  
                                              <TableCell padding="checkbox" onClick={handleScrollRight}>
                                                <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                                                <ArrowForwardIos color="#ffffff" sx={{width:"20px",fontSize:'1rem'}}/>
                                                  </IconButton>
                                                </TableCell>
                                  <TableCell align="center">
                                    {/* {projectData?.job_category_name=='Time & Material' ? '' :
                                    <Checkbox key={serviceIndex}
                                      sx={{cursor:'pointer'}}
                                      checked={(service?.taken==1) ? true : false}
                                      onChange={()=>{ handleServiceCheckboxChange(serviceIndex)}}
                                      color="primary"
                                    />
                                    } */}
                                    <Stack direction={'row'}>
                                    <Checkbox key={serviceIndex}
                                      sx={{cursor:'pointer'}}
                                      checked={(service?.taken==1) ? true : false}
                                      onChange={()=>{ handleServiceCheckboxChange(serviceIndex,service)}}
                                      color="primary"
                                    />
                                    {service.labour_cost_service_id === 10 &&
                                      services.filter(s => s.labour_cost_service_id === 10).length > 1 && (
                                        <IconButton
                                          size="small"
                                          onClick={() =>
                                            setOpenLabourIdx(prev =>
                                              prev === serviceIndex ? null : serviceIndex
                                            )
                                          }
                                        >
                                          {openLabourIdx === serviceIndex ? (
                                            <KeyboardArrowUp fontSize="small" />
                                          ) : (
                                            <KeyboardArrowDown fontSize="small" />
                                          )}
                                        </IconButton>
                                      )}
                                    </Stack>
                                  </TableCell>
                                     <TableCell align="center">
                                   {(service?.finalTaken==1  && projectData?.syncWithQuickbooks ==1) ? <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                   :""}
                                     </TableCell>
  
                                  <TableCell align="center">
                                    <Typography variant="subtitle2" style={{ color: 'yellow' }}>{service.__isRecipeGroup ? 'Production Labor' :service.name}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <Typography variant="subtitle2" style={{ color: 'yellow' }}>{service.__isRecipeGroup ? '' :service.recipeName}</Typography>
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      sx={{ width: '80%', color: 'yellow' }}
                                      type='number'
                                      label="Hours"
                                      value={parseFloat(service.qty || 0).toFixed(2)}
                                      disabled={true}
                                      InputProps={{
                                        inputProps: {
                                          min: 1
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      sx={{ width: '80%', color: 'yellow' }}
                                      type='number'
                                      label="Hours"
                                      value={parseFloat(service.jobcost_quantity || 0).toFixed(2)}
                                      disabled={!isEditing('services', serviceIndex)}
                                      onChange={(event) => {
                                        let newValue = parseFloat(event.target.value || 0);
                                        if (newValue < 0) newValue = 0
                                        
                                        setAllServices(prevState => {
                                          if (service.__isRecipeGroup) {
                                            // For recipe group: if manual is excluded, the display value already doesn't include manual hours
                                            // So we directly use newValue. Otherwise, subtract totalManualHours to get base value.
                                            const baseValue = excludeManualFromProductionLabor 
                                              ? Math.max(1, newValue) // When excluded, use value directly but ensure min 1
                                              : Math.max(0, newValue - totalManualHours); // When not excluded, subtract manual hours
                                            
                                            const recipeItems = prevState.filter(s => s.recipe_id != null && s.labour_cost_service_id !== 10);
                                            const totalRecipeQty = recipeItems.reduce((sum, s) => sum + Number(s.jobcost_quantity || 0), 0);
                                            
                                            return prevState.map(serviceItem => {
                                              if (serviceItem.recipe_id != null && serviceItem.labour_cost_service_id !== 10) {
                                                // Calculate proportion based on current quantities
                                                const proportion = totalRecipeQty > 0 
                                                  ? (Number(serviceItem.jobcost_quantity || 0) / totalRecipeQty) 
                                                  : (1 / recipeItems.length);
                                                // Round to 2 decimal places to fix floating-point precision issues
                                                const updatedQty = Math.round((baseValue * proportion) * 100) / 100;
                                                
                                                // Only update base recipe items - cost calculation: qty * originalCost
                                                return {
                                                  ...serviceItem,
                                                  jobcost_quantity: Math.max(0, updatedQty),
                                                  jobcost_total_cost: Number((Math.max(0, updatedQty) * serviceItem.originalCost).toFixed(2)),
                                                  taken: baseValue > 0 ? 1 : 0
                                                };
                                              }
                                              return serviceItem;
                                            });
                                          } else {
                                            // For non-recipe group items, update normally (preserve existing functionality)
                                            return prevState.map(serviceItem => {
                                              if (serviceItem.id === service.id) {
                                                const maxAllowedValue = Number(service.qty);
                                                const constrainedValue = Math.min(Number(newValue), maxAllowedValue);
                                                const taken = constrainedValue === maxAllowedValue ? 1 : 0;
                                                
                                                return {
                                                  ...serviceItem,
                                                  jobcost_quantity: newValue,
                                                  jobcost_total_cost: Number((newValue * serviceItem.originalCost).toFixed(2)),
                                                  taken: taken
                                                };
                                              }
                                              return serviceItem;
                                            });
                                          }
                                        });
                                      }}
                                      InputProps={{
                                        inputProps: {
                                          min: 1
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  {/* <TableCell align="center">
                                    <Typography variant="subtitle2" style={{ color: 'yellow' }}>${service.jobcost_unit_cost|| service.originalCost||service.unit_cost}</Typography>
                                  </TableCell> */}
                                  {/* <Typography variant="subtitle2" style={{ color: 'yellow' }}>${service.originalCost||service.unit_cost}</Typography> */}
                                  <TableCell align="center">
                                    {/* {projectData?.job_category_name=='Time & Material' ?  */}
                                      <Typography variant="subtitle2" style={{ color: 'yellow' }}>${service.jobcost_total_cost}</Typography>
                                    {/* :
                                      <Typography variant="subtitle2" style={{ color: 'yellow' }}>${((service.jobcost_quantity || service.qty)*(service.jobcost_unit_cost||service.originalCost||service.unit_cost))?.toFixed(2)}</Typography>
                                    } */}
                                    {/* <Typography variant="subtitle2" style={{ color: 'yellow' }}>${(service.qty)*(service.originalCost||service.unit_cost))?.toFixed(2)}</Typography> */}
                                  </TableCell>
  
                                                                      {/* <TableCell padding="checkbox" onClick={handleScrollLeft}>
                                     <IconButton sx={{ backgroundColor: theme.palette.divider,width:"35px",height:"35px" }} >
                                        <ArrowBackIos color="#ffffff" sx={{width:"20px",ml:0.5,fontSize:'1rem'}}/>
                                   </IconButton>
                                     </TableCell> */}
                                      <TableCell align="center">
                                        {!isEditing('services', serviceIndex) ? (
                                          <>
                                            <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                              {/* {service.finalTaken == 1 ? '' : ( */}
                                                <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('services', serviceIndex)}>
                                                  <Edit size="small" sx={{ fontSize: '24px' }} />
                                                </Button>
                                              {/* )} */}
                                                <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('services', serviceIndex, null, service.id, service.from_job, service.__isRecipeGroup)}>
                                                  <Delete size="small" sx={{ fontSize: '24px' }} />
                                                </Button>
                                              <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} onClick={handleScrollLeft}>
                                                <ArrowBackIos color="#ffffff" sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                              </IconButton>
                                            </Stack>
                                          </>
                                        ) : (
                                          <>
                                            <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                              <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleEditRow('services', serviceIndex, service?.id)}>
                                                <Done size="small" sx={{ fontSize: '24px' }} />
                                              </Button>
                                                <Button variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" onClick={() => handleDeleteRow('services', serviceIndex, null, service.id, service.from_job, service.__isRecipeGroup)}>
                                                  <Delete size="small" sx={{ fontSize: '24px' }} />
                                                </Button>
                                              <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} onClick={handleScrollLeft}>

                                                <ArrowBackIos color="#ffffff" sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                              </IconButton>
                                            </Stack>
                                          </>
                                        )}
                                      </TableCell>
                                </TableRow>
                                 {openLabourIdx === serviceIndex &&
                                  service.labour_cost_service_id === 10 && (
                                    <TableRow >
                                      {/* span the full width of the table (adjust colSpan to your column count) */}
                                      <TableCell colSpan={9} sx={{ p: 0 }}>
                                        <Collapse in={openLabourIdx === serviceIndex} timeout="auto" unmountOnExit>
                                          <Box px={2} py={1}>
                                            {/* mini-table */}   
                                            <Table size="small">
                                              <TableHead sx={{
                                                borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                                '& th': { backgroundColor: 'transparent' }
                                              }}>
                                                    <TableRow sx={{fontWeight:400}} >
                                                      <TableCell align='center' sx={{ width: '20%' }}>
                                                        <Typography variant="subtitle2" >Name</Typography>
                                                      </TableCell>
                                                      <TableCell sx={{ width: '30%' }}>
                                                        <Typography variant="subtitle2" >Product Formula</Typography>
                                                      </TableCell>
                                                      <TableCell align="center" sx={{ width: '20%' }}>
                                                        <Typography variant="subtitle2" >Expected Qty</Typography>
                                                      </TableCell>
                                                      <TableCell align="center" sx={{ width: '20%' }}>
                                                        <Typography variant="subtitle2" >Actual Qty</Typography>
                                                      </TableCell>
                                                      <TableCell align="right" sx={{ width: '25%' }}>
                                                        <Typography variant="subtitle2" >Total</Typography>
                                                      </TableCell>
                                                    </TableRow>
                                              </TableHead>
  
                                              <TableBody>
                                                {services
                                                  .filter(r => r.labour_cost_service_id === 10)
                                                  .map((row, i) => (
                                                    <TableRow key={i} sx={{fontWeight:400}}>
                                                      <TableCell>
                                                        <Typography variant="subtitle2" style={{ color: 'yellow' }}>{row.name}</Typography>
                                                      </TableCell>
                                                      <TableCell>
                                                        <Typography variant="subtitle2" >{row?.recipeName}</Typography>
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        <Typography variant="subtitle2" >{row?.qty}</Typography>
                                                      </TableCell>
                                                      <TableCell align="center">
                                                        <Typography variant="subtitle2" >{row?.jobcost_quantity}</Typography>
                                                      </TableCell>
                                                      <TableCell align="right">
                                                        <Typography variant="subtitle2" style={{ color: 'yellow' }}>${row.jobcost_total_cost}</Typography>
                                                      </TableCell>
                                                    </TableRow>
                                                  ))}
                                              </TableBody>
                                            </Table>
                                          </Box>
                                        </Collapse>
                                      </TableCell>
                                    </TableRow>
                                  )}
                              </React.Fragment>
                              ))
                              }
                              {/* Separate Production Labor row for project category 12 (Time & Material) */}
                              {projectData?.project_category === 12 && (() => {
                                // For Time & Material, get all manually added payouts (from allPayouts)
                                const manuallyAddedPayoutsForTM = allPayouts?.filter(
                                  p => (p.is_manually_added === 1 || p.is_manually_added === "1")
                                ) || [];
                                
                                const manuallyAddedPayoutsTotalForCost = manuallyAddedPayoutsForTM.reduce(
                                  (sum, p) => sum + parseFloat(p.amount || 0), 0
                                ) || 0;
                                
                                const hasManualTasks = (totalManualHours > 0 || manuallyAddedPayoutsTotalForCost > 0);
                                
                                if (!hasManualTasks) return null;
                                
                                return (
                                  <React.Fragment key={`production_labor_12`}>
                                    <TableRow
                                      sx={{
                                        borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                        backgroundColor: theme.palette.divider,
                                      }}
                                    >
                                      <TableCell padding="checkbox" onClick={handleScrollRight}>
                                        <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }}>
                                          <ArrowForwardIos color="#ffffff" sx={{ width: "20px", fontSize: '1rem' }} />
                                        </IconButton>
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <Stack direction={'row'}>
                                          <Checkbox
                                            sx={{ cursor: 'not-allowed' }}
                                            checked={true}
                                            color="primary"
                                          />
                                        </Stack>
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        {(projectData?.syncWithQuickbooks == 1) ? 
                                          <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover" }} />
                                          : ""}
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <Typography variant="subtitle2" style={{ color: 'yellow' }}>Production Labor</Typography>
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <Typography variant="subtitle2" style={{ color: 'yellow' }}></Typography>
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <TextField
                                          sx={{ width: '80%', color: 'yellow' }}
                                          type='number'
                                          label="Hours"
                                          value={parseFloat(totalManualHours || 0).toFixed(2)}
                                          disabled={true}
                                          InputProps={{
                                            inputProps: {
                                              min: 0
                                            }
                                          }}
                                        />
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <TextField
                                          sx={{ width: '80%', color: 'yellow' }}
                                          type='number'
                                          label="Hours"
                                          value={parseFloat(totalManualHours || 0).toFixed(2)}
                                          disabled={true}
                                          InputProps={{
                                            inputProps: {
                                              min: 0
                                            }
                                          }}
                                        />
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <Typography variant="subtitle2" style={{ color: 'yellow' }}>
                                          ${parseFloat(manuallyAddedPayoutsTotalForCost || 0).toFixed(2)}
                                        </Typography>
                                      </TableCell>
                                      
                                      <TableCell align="center">
                                        <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                          <Tooltip title="Production Labor for Time & Material cannot be edited. It is derived from manually added tasks." placement="top">
                                            <span>
                                              <Button disabled variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small">
                                                <Edit size="small" sx={{ fontSize: '24px' }} />
                                              </Button>
                                            </span>
                                          </Tooltip>
                                          <Tooltip title="Production Labor for Time & Material cannot be deleted. It is derived from manually added tasks." placement="top">
                                            <span>
                                              <Button disabled variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small">
                                                <Delete size="small" sx={{ fontSize: '24px' }} />
                                              </Button>
                                            </span>
                                          </Tooltip>
                                          <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} onClick={handleScrollLeft}>
                                            <ArrowBackIos color="#ffffff" sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                          </IconButton>
                                        </Stack>
                                      </TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                );
                              })()}
                              {
                                additionalMaterials?.map((material, index) => (
                                  <TableRow
                                    key={index}
                                    sx={{
                                      borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                                      backgroundColor: material.taken === 1 ? theme.palette.divider : null
                                    }}
                                  >
                                    {/* Scroll Right */}
                                    <TableCell padding="checkbox" onClick={handleScrollRight}>
                                      <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }}>
                                        <ArrowForwardIos sx={{ width: "20px", fontSize: '1rem' }} />
                                      </IconButton>
                                    </TableCell>
  
                                    {/* Checkbox */}
                                    <TableCell align="center">
                                      <Stack direction="row">
                                        {/* <Checkbox
                                          checked={material.taken === 1}
                                          onChange={() => handleMaterialCheckboxChange(index, material)}
                                          color="primary"
                                        /> */}
                                      </Stack>
                                    </TableCell>
  
                                    
                                    <TableCell align="center">
                                      {(material?.taken == 1 &&  projectData?.syncWithQuickbooks) ? 
                                      <Avatar src={QbLogo} alt="QB" sx={{ width: 30, height: 30, objectFit: "cover",}}/>
                                        :""}
                                    </TableCell>
  
                                    <TableCell align="center">
                                      <Box sx={{ maxWidth: 130, justifyContent: 'center', alignItems: 'center' }}>
                                        <Tooltip title={material.name + (material?.inhouse == 1 ? ' (Inhouse)' : ' (Client owned)')+(material?.partial==1?'Partial':'Finished')}>
                                          <Typography variant="subtitle2" sx={{color: material?.isMaterial ==1 ? "#ffc0cb" : '#1ccaff', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                                            {material.name} {material?.inhouse == 1 ? ' (I)' : ' (C)'}
                                          </Typography>
                                        </Tooltip>
                                        <Typography variant="subtitle2" sx={{color: material?.isMaterial ==1 ? "#ffc0cb" : '#1ccaff'}}>{material?.barcode}</Typography>
                                        <span style={{ color: material?.isMaterial ==1 ? theme.palette.error.main : "#1ccaff" }}>
                                          {additionalMaterials?.filter(item => item.id === material?.id)?.reduce((accumulator, currentValue) => {
                                            const initialQuantity = initialMaterials?.find(item => item.product_id === material.id)?.quantity || 0;
                                            const productQuantity = productList?.find(item => item.id === material.id)?.qty || 0;
                                             const stock = (initialQuantity + productQuantity)  //- currentValue?.quantity;
                                            return stock >= 0 ? ('Stock left : ' + stock.toFixed(2)) : '';
                                          }, 0) || ''}
                                        </span>
                                      </Box>
                                    </TableCell>
                                    {/* Material name */}
                                    {/* <TableCell align="center">
                                      <Typography variant="subtitle2" style={{ color: '#ffc0cb' }}>
                                        {material.productName}
                                      </Typography>
                                    </TableCell> */}
  
                                    {/* Recipe (or empty) */}
                                    <TableCell align="center">
                                      <Typography variant="subtitle2" style={{ color:material?.isMaterial == 1 ? '#ffc0cb' : '#1ccaff' }}>
                                        {'N/A'}
                                      </Typography>
                                    </TableCell>
  
                                    {/* Quantity */}
                                    <TableCell align="center">
                                      <TextField
                                        sx={{ width: '80%', color:material?.isMaterial == 1 ? '#ffc0cb' : '#1ccaff'}}
                                        type="number"
                                        label="Qty"
                                        value={material.quantity}
                                        disabled={true}
                                        InputProps={{ inputProps: { min: 1 } }}
                                      />
                                    </TableCell>
  
                                    {/* Jobcost quantity */}
                                    <TableCell align="center">
                                      {/* <TextField
                                        sx={{ width: '80%', color: '#ffc0cb' }}
                                        type="number"
                                        label="Material Qty"
                                        value={Number(material.quantity)}
                                        disabled={true}
                                        InputProps={{ inputProps: { min: 1 } }}
                                      /> */}
                                    </TableCell>
  
                                    {/* Total cost */}
                                    <TableCell align="center">
                                      <Typography variant="subtitle2" style={{ color:material?.isMaterial == 1 ? '#ffc0cb' : '#1ccaff' }}>
                                        ${material.total}
                                      </Typography>
                                    </TableCell>
  
                                    {/* Scroll Left */}
                                    {/* <TableCell padding="checkbox" onClick={handleScrollLeft}>
                                      <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }}>
                                        <ArrowBackIos sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                      </IconButton>
                                    </TableCell> */}
                                    <TableCell align="center">
                                    <Stack direction={'row'} alignItems={'center'} spacing={1}>
                                      {/* {service.finalTaken == 1 ? '' : ( */}
                                        <Tooltip title={`${material?.isMaterial !== 1 ? "Catalog" : "Additional materials"} cannot be edited directly. Click 'Add Material/Catalog' button below to manage materials.`} placement="top">
                                          <span>
                                            <Button disabled variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small">
                                              <Edit size="small" sx={{ fontSize: '24px' }} />
                                            </Button>
                                          </span>
                                        </Tooltip>
                                      {/* )} */}
                                        <Tooltip title={`${material?.isMaterial !== 1 ? "Catalog" : "Additional materials"} cannot be deleted directly. Click 'Add Material/Catalog' button below to manage materials.`} placement="top">
                                          <span>
                                            <Button disabled variant='outlined' color='inherit' sx={{ boxShadow: 'none', minWidth: '40px', padding: '5px 9px' }} size="small" >
                                              <Delete size="small" sx={{ fontSize: '24px' }} />
                                            </Button>
                                          </span>
                                        </Tooltip>
                                      <IconButton sx={{ backgroundColor: theme.palette.divider, width: "35px", height: "35px" }} onClick={handleScrollLeft}>
                                        <ArrowBackIos color="#ffffff" sx={{ width: "20px", ml: 0.5, fontSize: '1rem' }} />
                                      </IconButton>
                                    </Stack>
                                    </TableCell>
                                  </TableRow>
                                ))
                              }
  
                            </TableBody>
                          </Table>
                        </TableContainer>
  
                      </Scrollbar>
                      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2, mb: 4, flexDirection: { xs: 'column', md: 'row' }, alignItems:'center', gap: 1, }}>
                        <Button
                          variant='outlined'
                          startIcon={<Stack className='lets-icons--add-duotone' />}
                          type="button"
                          size='large'
                          onClick={() => handleClick()}
                        >
                          {projectData?.job_category_name == 'Time & Material' ? 'Add Material' : 'Add Material / Catalog'}
                        </Button>
                        <Button
                          variant='outlined'
                          type="button"
                          size='large'
                          startIcon={<Add />}
                          onClick={() => {
                            fetchAvailableServices();
                            setServicesPage(0); // Reset to first page
                            setServicesRowsPerPage(10); // Reset to default rows per page
                            setServicesPreview(true);
                          }}
                        >
                          Add Service
                        </Button>
                      </Box>
                      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                      <Box>
                      <RowResultStyle>
                        {/* <TableCell colSpan={3} /> */}
                        <TableCell align="right" colSpan={4} >
                          {/* <Typography variant="h6">{ projectData?.job_category_name=='Time & Material' ? "Material Cost":"Additional Material Cost"}</Typography> */}
                          <Typography variant="h6">Material Cost</Typography>
                        </TableCell>
                        <TableCell align="center" width={100}>
                          <Typography variant="h6">
                            {/* {materialPayOut.toFixed(2) || 0} */}
                            {/* {(parseFloat(materialPayOut || 0) + parseFloat(materialTotal || 0)).toFixed(2)} */}
                            {(parseFloat(materialPayOut || 0) + parseFloat(materialTotal || 0) + parseFloat(totalStockCost || 0)).toFixed(2)}
                            </Typography>
                        </TableCell>
                      </RowResultStyle>
  
                      {/* {projectData?.job_category_name=='Time & Material' ? "" : */}
                      <RowResultStyle>
                        <TableCell align="right" colSpan={4} >
                          <Typography variant="h6">Additional Services</Typography>
                        </TableCell>
                        <TableCell align="center" width={100}>
                          <Typography variant="h6">
                            {parseFloat(additionalLaborCost1).toFixed(2)}
                            {/* {projectData?.job_category_name=='Time & Material' ? '0.00' :
                            (services?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if(currentValue.recipe_id == null && currentValue?.taken == 1){
                                newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity
                                // newTotal = currentValue?.originalCost * currentValue?.qty
                              }
                              return accumulator + newTotal;
                            }, 0) || 0).toFixed(2)} */}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                      {/* } */}
                      {/* <RowResultStyle>
                      <TableCell align="right" colSpan={4} >
                        <Typography variant="h6">Additional Labour Cost</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">{additionalServices || 0}</Typography>
                      </TableCell>
                    </RowResultStyle> */}
  
                    {/* {projectData?.job_category_name=='Time & Material' ? "" : */}
                      <RowResultStyle>
                        {/* <TableCell  width={240}/> */}
                        <TableCell align="right" colSpan={4} >
                          {/* <Typography variant="h6">Actual Product Formula Cost</Typography> */}
                          <Typography variant="h6">Production Labor</Typography>
                        </TableCell>
                        {/* <TableCell align="center">
                        <Typography variant="h6" sx={{ whiteSpace: { xs: 'none', md: 'nowrap' }, width: '100%', ml: 3 }}>
                          {`${selectedProjects?.reduce((accumulator, currentValue) => {
                            return accumulator + (currentValue?.unit_cost * currentValue?.quantity);
                          }, 0) + services?.reduce((accumulator, currentValue) => {
                            return accumulator + (currentValue?.originalCost * currentValue?.qty);
                          }, 0) || 0} (${selectedProjects?.reduce((accumulator, currentValue) => {
                            return accumulator + (currentValue?.unit_cost * currentValue?.quantity);
                          }, 0) || 0} + ${services?.reduce((accumulator, currentValue) => {
                            return accumulator + (currentValue?.originalCost * currentValue?.qty);
                          }, 0) || 0})`}
                        </Typography>
                      </TableCell> */}
                        <TableCell align="center">
                          <Typography variant="h6" sx={{ whiteSpace: { xs: 'none', md: 'nowrap' } }}>
                            {/* {`${(selectedProjects?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if(currentValue?.taken == 1){
                                newTotal = currentValue?.jobcost_total
                                // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity // currentValue?.unit_cost * currentValue?.quantity
                              }
                              return accumulator + newTotal;
                            }, 0) + 
                            services?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if((currentValue.recipe_id && currentValue?.labour_cost_service_id !== 10) && currentValue?.taken == 1){
                                const initialCost = ((currentValue?.originalCost || 0) * (currentValue?.qty || 0)) || 0
                                newTotal = (initialCost > parseFloat(currentValue?.jobcost_total_cost || 0)) ? parseFloat(currentValue?.jobcost_total_cost || 0) : initialCost
                                // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity // currentValue?.originalCost * currentValue?.qty
                              }
                              return accumulator + newTotal;
                            }, 0)).toFixed(2)} 
                            (${(selectedProjects?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if(currentValue?.taken == 1){
                                newTotal = currentValue?.jobcost_total
                                // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity // currentValue?.unit_cost * currentValue?.quantity
                              }
                              return accumulator + newTotal;
                            }, 0) || 0).toFixed(2)} + ${(services?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if((currentValue.recipe_id && currentValue?.labour_cost_service_id !== 10) && currentValue?.taken == 1){
                                // newTotal = currentValue?.originalCost * currentValue?.qty
                                // newTotal = currentValue?.jobcost_unit_cost * currentValue?.jobcost_quantity
                                const initialCost = ((currentValue?.originalCost || 0) * (currentValue?.qty || 0)) || 0
                                newTotal = (initialCost > parseFloat(currentValue?.jobcost_total_cost || 0)) ? parseFloat(currentValue?.jobcost_total_cost || 0) : initialCost
                                // newTotal = parseFloat(currentValue?.jobcost_total_cost || 0)
                              }
                              return accumulator + newTotal;
                            }, 0)).toFixed(2)})`}  */}
  
                            {/* {(services?.reduce((accumulator, currentValue) => {
                              let newTotal = 0;
                              if((currentValue.recipe_id && currentValue?.labour_cost_service_id !== 10) && currentValue?.taken == 1){
                                const initialCost = ((currentValue?.originalCost || 0) * (currentValue?.qty || 0)) || 0
                                newTotal = (initialCost > parseFloat(currentValue?.jobcost_total_cost || 0)) ? parseFloat(currentValue?.jobcost_total_cost || 0) : initialCost
                              }
                              return accumulator + newTotal;
                            }, 0)).toFixed(2)} */}
                            { parseFloat(productionLabourTotal).toFixed(2)}
                          </Typography>
                        </TableCell>
  
                      </RowResultStyle>
                     {/* } */}
                     <RowResultStyle>
                        <TableCell align="right" colSpan={4} >
                          <Typography variant="h6">Install Labor</Typography>
                        </TableCell>
                        <TableCell align="center" width={100}>
                          <Typography variant="h6">
                            { parseFloat(installLaborCost).toFixed(2)}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
  
                      <RowResultStyle>
                        {/* <TableCell colSpan={3} /> */}
                        <TableCell align="right" colSpan={4} >
                          {/* <Typography variant="h6">{projectData?.job_category_name=='Time & Material' ? "Service Cost" : "Excess Labor Cost"}</Typography> */}
                          <Typography variant="h6">Excess Labor Cost</Typography>
                        </TableCell>
                        <TableCell align="center" width={100}>
                          <Typography variant="h6">
                            {/* {projectData?.job_category_name=='Time & Material' ? (parseFloat(additionalLaborCost1)).toFixed(2) : parseFloat(excessLaborCost1).toFixed(2)} */}
                            { parseFloat(excessLaborCost1).toFixed(2)}
                            {/* {Math.max(
                              0,
                              (
                                Math.max(
                                  0,
                                  manualTotalPayOut
                                    ? parseFloat(manualTotalPayOut.toFixed(2))
                                    : 0
                                ) +
                                (hourlyTotalPayOut
                                  ? parseFloat(hourlyTotalPayOut.toFixed(2))
                                  : 0)
                              ) -
                              ((projectData?.job_category_name=='Time & Material' ? 0 :
                                (services?.reduce((accumulator, currentValue) => {
                                  return accumulator + Number(currentValue?.jobcost_total_cost || 0);
                                }, 0) || 0)) + Number(additionalServices || 0)
                              )
                            ).toFixed(2)} */}
                          </Typography>
                        </TableCell>
                      </RowResultStyle>
                      {/* <RowResultStyle>
                        <TableCell align="right" colSpan={4} >
                        <Typography variant="h6">Manual Staff Pay Out</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">{manualTotalPayOut ? manualTotalPayOut?.toFixed(2) : 0}</Typography>
                      </TableCell>
                    </RowResultStyle> */}
                      {/* <RowResultStyle>
                        <TableCell align="right" colSpan={4} >
                          <Typography variant="h6">Hourly Staff Pay Out</Typography>
                      </TableCell>
                      <TableCell align="center" width={100}>
                        <Typography variant="h6">{hourlyTotalPayOut ? hourlyTotalPayOut?.toFixed(2) : 0}</Typography>
                      </TableCell>
                    </RowResultStyle> */}
  
                      <RowResultStyle>
                        {/* <TableCell colSpan={3} />  */}
                        {/* <TableCell align="center" width={240}> */}
                        <TableCell align="right" colSpan={4} sx={{color:'#fc8c03'}} >
                          <Typography variant="h6">Total Cost</Typography>
  
                        </TableCell>
                        <TableCell align="center" width={100} sx={{color:'#fc8c03'}}>
                          <Typography variant="h6">{grandTotalCost ? grandTotalCost?.toFixed(2) : 0}</Typography>
  
                        </TableCell>
  
                      </RowResultStyle>
                      </Box>
                      </Box>
                      {/* {currentTab =="Installations" ? '' : */}
                      <Box sx={{ display: 'flex', justifyContent: 'center', }}>
                       <Tooltip 
    title="1.When a job is in progress in QuickBooks, the amount should be debited to (WIP – Materials & WIP – Labor) and credited to (Inventory Asset & Payroll Clearing) . 
           2.When the job is completed, the total job cost amount should be debited to (Finished Goods Inventory) and credited to (WIP – Materials & Labor)." 
    placement="top"
  >
    <Info sx={{ mt: 0.5 }} />
  </Tooltip>
                        <LoadingButton disabled={projectData?.installation_acceptance === 1} loading={isSubmitting} sx={{ borderRadius: '20px', mx: 3, mb: 1, width: '80%', boxShadow:'none' }} type="submit" variant="contained">
                          Submit
                        </LoadingButton>
                      </Box>
                      {/* } */}
                    </Form>
                  </FormikProvider>
                </Card>
                {/* <Tooltip title={isHidden ? 'Show Sidebar' : 'Hide Sidebar'} placement="top">
                  <IconButton
                    onClick={() => setIsHidden(!isHidden)}
                    sx={{
                      position: 'absolute',
                      top: 13,
                      left: -7, //'calc(100% - 12px)',
                      zIndex: 10,
                      backgroundColor: '#f5f5f528',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      width: 30,
                      height: 40,
                      color: '#ffffff',
                      '&:hover': {
                        backgroundColor: '#44424263',
                      },
                      transition: 'all 0.2s ease-in-out',
                    }}
                  >
                    {isHidden ? <ArrowForwardIos fontSize="small" /> : <ArrowBackIos fontSize="small" sx={{marginLeft: '7px'}} />}
                  </IconButton>
                </Tooltip> */}
                </Box>
              </Grid>
            </Grid>
              {/* {projectData?.project_category !== 12 ? (
                <JobCostMemberClockInTimer
                  logs={logs}
                  fetchData={fetchData}
                  staffTimelogsGet={staffTimelogsGet}
                  setStaffTimelogsGet={setStaffTimelogsGet}
                  projectMembers={projectMembers}
                  setProjectMembers={setProjectMembers}
                  projectTasks={projectTasks}
                  setProjectTasks={setProjectTasks}
                  setLogs={setLogs}
                  fetchJobCostLogs={fetchJobCostLogs}
                  services={services}
                  userId={user?.user_id}
                  userType={user?.user_type}
                  projectData={projectData}
                  subTaskId={projectTasks?.[0]?.id}
                />
              ) : ''} */}
              <JobCostMemberClockInTimer
                  logs={logs}
                  fetchData={fetchData}
                  staffTimelogsGet={staffTimelogsGet}
                  setStaffTimelogsGet={setStaffTimelogsGet}
                  projectMembers={projectMembers}
                  setProjectMembers={setProjectMembers}
                  projectTasks={projectTasks}
                  setProjectTasks={setProjectTasks}
                  setLogs={setLogs}
                  fetchJobCostLogs={fetchJobCostLogs}
                  services={services}
                  userId={user?.user_id}
                  userType={user?.user_type}
                  projectData={projectData}
                  subTaskId={projectTasks?.[0]?.id}
                />
              {/* {projectData?.project_category !== 12 ? (
                <JobCostLogsListing
                  logs={logs}
                  projectData={projectData}
                  setLogs={setLogs}
                  fetchJobCostLogs={fetchJobCostLogs} />
              ) : ''} */}
              <JobCostLogsListing
                  logs={logs}
                  projectData={projectData}
                  setLogs={setLogs}
                  fetchJobCostLogs={fetchJobCostLogs} />
          </Paper>
        </Container>
        <ConfirmationPopup
          open={confirmationPopup.open}
          handleClick={confirmationPopup.handleClick}
          handleClose={confirmationPopup.handleClose}
          message={confirmationPopup.message}
        />
        
        {/* Edit Service Confirmation Popup */}
        <Dialog open={editServiceConfirmation.open} onClose={handleEditServiceCancel}>
          <DialogContent>
            <Alert severity="warning">
              When we edit the hours, any already clocked-in data (if present) will be cleared and replaced with the service hourly cost. If no clock-in data exists, only the service hourly cost will be applied. Are you sure?
            </Alert>
            {editServiceConfirmation.isProductionLabor && (manuallyAddedPayouts?.length > 0) && (
              <Alert severity="error" sx={{ mt: 2 }}>
                Note: This is Production Labor with manually added task clock-in data. The manual hours ({totalManualHours.toFixed(2)}) and manually added payouts will be removed from the calculation. The manually added task clock-in data will be cleared.
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' color='inherit' onClick={handleEditServiceCancel}>
              No
            </Button>
            <Button 
              variant='contained' 
              color='primary' 
              onClick={handleEditServiceConfirm}
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        {
          materialsPreview && (
            <Modal
              open={materialsPreview}
              handleClose={() => {
                setMaterialsPreview(false);
                setIsRecipe(false)
              }}
              modalTitle={'Select material'}
            >
              {isRecipe ? (
                <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                  <Grid item xs={12} md={10}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                      spacing={3}
                    >
                      <Stack
                        direction={{ xs: 'column', md: 'column' }}
                        display="flex"
                        justifyContent="space-between"
                        spacing={3}
                      >
                        {console.log("#####selectedMaterial", selectedMaterial)}
                        <Stack direction={{ xs: 'column', md: 'row' }}>
                          <Typography variant="body" sx={{ display: 'flex', alignItems: 'center' }}>
                            Material Name :
                            <span style={{ color: theme.palette.primary.dark, fontWeight: 'bold', paddingRight: "2" }}>
                              <Autocomplete
                                sx={{ ml: 1, width: 300 }}
                                id="combo-box-demo"
                                options={selectedMaterial.ingredients}
                                value={ingredient}
                                onChange={(event, newValue) => setIngredient(newValue)}
                                renderInput={(params) => (
                                  <TextField {...params}
                                    label="Select a Material" />
                                )}
                                getOptionLabel={(option) => option.name ? option.name : ''}
                              />
                            </span>
                            Quantity : {selectedMaterial?.ingredients?.find(item => item.product_id === ingredient?.product_id)?.quantity}
                          </Typography>
                        </Stack>




                        {/* <Card> */}
                        <Scrollbar>
                          <TableContainer>
                            <Table>
                              <TableHead sx={{ width: '100%' }}>
                                <TableRow>
                                  <TableCell align='center'>#</TableCell>
                                  <TableCell align='center'>Barcode</TableCell>
                                  <TableCell align='center'>Unit Cost</TableCell>
                                  <TableCell align='center'>Available Stock</TableCell>
                                  <TableCell align='center'></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {loading ? (
                                  <CircularProgress color="primary" variant="indeterminate" />
                                ) : (

                                  <>
                                    {productWithQty?.filter((data) => (data?.material_id === ingredient?.product_id)).map((row, index) => {
                                      let { id, name, unit_cost, qty, barcode } = row;

                                      const isAlreadyAdded = selectedProjects.some(project => project.material_id === row.material_id);

                                      let totalQuantityInSelectedProjects = 0;

                                      if (isAlreadyAdded) {
                                        totalQuantityInSelectedProjects = selectedProjects.reduce((total, project) => {
                                          if (project.material_id === row.material_id) {
                                            return total + project.quantity;
                                          }
                                          return total;
                                        }, 0);
                                      }

                                      let quantity = selectedMaterial?.ingredients?.find(item => item.product_id === ingredient?.product_id)?.quantity || 1;

                                      if (qty < quantity) {
                                        quantity = qty;
                                      }
                                      console.log("selectedprojects.Product Formula", selectedMaterial.name);
                                      return (
                                        <TableRow
                                          hover
                                          key={index}
                                          tabIndex={-1}
                                          sx={{
                                            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                          }}
                                        >
                                          <TableCell align='center'> {index + 1} </TableCell>
                                          <TableCell align="center"> {barcode} </TableCell>
                                          <TableCell align="center"> ${unit_cost} </TableCell>
                                          <TableCell align="center"> {qty} </TableCell>
                                          <TableCell align="center">
                                            <Button
                                              onClick={() => {
                                                if (!selectedProjects.map(s => s.id).includes(id)) {
                                                  if (totalQuantityInSelectedProjects > 0) {
                                                    let newQuantity = Math.max(0, quantity - totalQuantityInSelectedProjects);
                                                    if (newQuantity === 0) {
                                                      enqueueSnackbar('Material Stock exceed', { variant: 'error' });
                                                      return;
                                                    }
                                                    handleProjectClick({ ...row, quantity: newQuantity, recipeName: selectedMaterial.name });
                                                  } else {
                                                    handleProjectClick({ ...row, quantity: quantity, recipeName: selectedMaterial.name });
                                                  }
                                                } else {
                                                  enqueueSnackbar('Material Already Added', { variant: 'error' });
                                                }
                                              }}
                                            >
                                              <AddCircle />
                                            </Button>
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </>


                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                        {/* </Card> */}
                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                          <Button variant='outlined' onClick={() => { setMaterialsPreview(false); setSelectedMaterial(null); }}>Close</Button>
                        </Box>
                      </Stack>

                    </Stack>
                  </Grid>
                </Grid>) :
                (<Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                  <Grid item xs={12} md={10}>
                    <Stack
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                      spacing={3}
                    >
                      <Stack
                        direction={{ xs: 'column', md: 'column' }}
                        display="flex"
                        justifyContent="space-between"
                        spacing={3}
                      >
                        {console.log("#####selectedMaterial", selectedMaterial)}
                        <Stack direction={{ xs: 'column', md: 'column' }}>
                          <Typography variant="body">
                            Material Name : <span style={{ color: theme.palette.primary.dark, fontWeight: 'bold' }}>{selectedMaterial?.name}</span>
                          </Typography>
                        </Stack>

                        {/* <Card> */}
                        <Scrollbar>
                          <TableContainer>
                            <Table>
                              <TableHead sx={{ width: '100%' }}>
                                <TableRow>
                                  <TableCell align='center'>#</TableCell>
                                  <TableCell align='center'>Barcode</TableCell>
                                  <TableCell align='center'>Unit Cost</TableCell>
                                  <TableCell align='center'>Available Stock</TableCell>
                                  <TableCell align='center'></TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {loading ? (
                                  <CircularProgress color="primary" variant="indeterminate" />
                                ) : (
                                  <>
                                    {productWithQty?.filter((data) => (data?.material_id === selectedMaterial?.id)).map((row, index) => {
                                      // console.log('selectedProjects------',selectedProjects);
                                      // console.log('selectedMaterial------',selectedMaterial);
                                      let { id, name, unit_cost, qty, barcode } = row;
                                      return (
                                        <TableRow
                                          hover
                                          key={index}
                                          tabIndex={-1}
                                          sx={{
                                            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                          }}
                                        >
                                          <TableCell align='center'> {index + 1} </TableCell>
                                          <TableCell align="center"> {barcode} </TableCell>
                                          <TableCell align="center"> ${unit_cost} </TableCell>
                                          <TableCell align="center"> {qty} </TableCell>
                                          <TableCell align="center">
                                            <Button
                                              onClick={() => !selectedProjects.map(s => s.id).includes(id) ? handleProjectClick({ ...row, quantity: 1 }) : enqueueSnackbar('Material Already Added', { variant: 'error' })}
                                            >
                                              <AddCircle />
                                            </Button>
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </>
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>
                        {/* </Card> */}
                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                          <Button variant='outlined' onClick={() => { setMaterialsPreview(false); setSelectedMaterial(null); }}>Close</Button>
                        </Box>
                      </Stack>

                    </Stack>
                  </Grid>
                </Grid>)}
            </Modal>
          )
        }
        {servicesPreview && (
          <Modal
            open={servicesPreview}
            handleClose={() => {
              setServicesPreview(false);
              setServiceExpectedHours({});
              setServiceSearchTerm('');
              fetchAvailableServices();
            }}
            modalTitle={'Select Service'}
          >
            <Grid item xs={12} md={12} sx={{ marginBottom: 2,pl: 1, }}>
              <Alert severity="error" size='small'>Note : If the expected hours are 0, then while editing the job cost, the amount will be added to Excess Labor Cost.</Alert>
            </Grid>
            <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
              <Grid item xs={12} md={12}>
                <Box sx={{ display: 'flex', justifyContent: 'center',alignItems: 'center',width: '100%' }}>
                <TextField
                  // fullWidth
                  size='small'
                  label={'Search Services'}
                  placeholder='Search by service name...'
                  value={serviceSearchTerm}
                  onChange={(e) => setServiceSearchTerm(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    )
                  }}
                  sx={{ mb: 2,width: '80%' }}
                />
                </Box>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                  }}
                  spacing={3}
                >
                  <Stack
                    direction={{ xs: 'column', md: 'column' }}
                    display="flex"
                    justifyContent="space-between"
                    spacing={3}
                  >

                    <Scrollbar>
                      <TableContainer>
                        <Table>
                          <TableHead sx={{ width: '100%' }}>
                            <TableRow>
                              <TableCell align='center'>#</TableCell>
                              <TableCell align='center'>Service Name</TableCell>
                              <TableCell align='center'>Service Type</TableCell>
                              <TableCell align='center'>Cost</TableCell>
                              <TableCell align='center'>Workflow</TableCell>
                              <TableCell align='center'>Expected Hours</TableCell>
                              <TableCell align='center'></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {availableServices
                              ?.filter(service => 
                                service.name?.toLowerCase().includes(serviceSearchTerm.toLowerCase()) ||
                                service.type_name?.toLowerCase().includes(serviceSearchTerm.toLowerCase())
                              )
                              ?.slice(servicesPage * servicesRowsPerPage, servicesPage * servicesRowsPerPage + servicesRowsPerPage)
                              ?.map((service, index) => {
                              const isAlreadyAdded = services.some(s => s.labour_cost_service_id === service.id);
                              return (
                                <TableRow
                                  hover
                                  key={index}
                                  tabIndex={-1}
                                  sx={{
                                    borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                                  }}
                                >
                                  <TableCell align='center'>{servicesPage * servicesRowsPerPage + index + 1}</TableCell>
                                  <TableCell align="center">{service.name}</TableCell>
                                  <TableCell align="center">{service.type_name || 'N/A'}</TableCell>
                                  <TableCell align="center">${service.cost || 0}</TableCell>
                                  <TableCell align="center">{service.workflow_name || 'N/A'}</TableCell>
                                  <TableCell align="center">
                                    <TextField
                                      type="number"
                                      size="small"
                                      placeholder="0"
                                      disabled={isAlreadyAdded}
                                      inputProps={{
                                        min: 0,
                                        step: 0.5
                                      }}
                                      sx={{ width: '80px' }}
                                      defaultValue={0}
                                      onChange={(e) => {
                                        const hours = parseFloat(e.target.value) || 0;
                                        setServiceExpectedHours(prev => ({
                                          ...prev,
                                          [service.id]: hours
                                        }));
                                      }}
                                      value={serviceExpectedHours[service.id] || 0}
                                    />
                                  </TableCell>
                                  <TableCell align="center">
                                    <Button
                                      onClick={() => handleServiceAdd(service)}
                                      disabled={isAlreadyAdded}
                                      variant={isAlreadyAdded ? "outlined" : "outlined"}
                                      color={isAlreadyAdded ? "inherit" : "primary"}
                                      sx={{ boxShadow: 'none' }}
                                    >
                                      {isAlreadyAdded ? 'Added' : <AddCircle />}
                                    </Button>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={availableServices?.filter(service => 
                          service.name?.toLowerCase().includes(serviceSearchTerm.toLowerCase()) ||
                          service.type_name?.toLowerCase().includes(serviceSearchTerm.toLowerCase())
                        )?.length || 0}
                        rowsPerPage={servicesRowsPerPage}
                        page={servicesPage}
                        onPageChange={handleServicesChangePage}
                        onRowsPerPageChange={handleServicesChangeRowsPerPage}
                      />
                    </Scrollbar>
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
                      <Button variant='outlined' onClick={() => { setServicesPreview(false); }}>Close</Button>
                    </Box>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Modal>
        )}
        {jobCostPreview && (
          <Modal
            open={jobCostPreview}
            handleClose={() => {
              setJobCostPreview(false);
            }}
            modalTitle={
              <>
              {"Job Cost Calculator "}
              {projectData?.job_category_name === 'Time & Material' ? <Label variant="filled" color="info">T&M</Label> : ''}
              </>
            }
            width={1200}
          >
            <CompareJobCost id={id} />
          </Modal>
        )}
      </Page >
  );
}
